// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:04:38.753Z
// Property: Valley Park Apartments (ID: 6767906449166359)
// Collections: 30 amenities, 8 floorplans (live), 25 photos, 80 POIs, 2 reviews, 1 virtual tours, 7 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166359",
  "property_external_id": "30942",
  "property_zillow_url": "https://www.zillow.com/apartments/bethlehem-pa/valley-park/5XrSV4/",
  "property_apartments_url": "https://www.apartments.com/valley-park-apartments-bethlehem-pa/yr9mdtr/",
  "property_google_business_url": "https://www.google.com/maps/place/Valley+Park+Apartment+Homes/data=!4m2!3m1!1s0x0:0xad11c4553f913ac8?sa=X&ved=2ahUKEwiUyfqfi7mSAxXsliYFHSysCjAQ_BJ6BAg6EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "valley-park-apartments",
  "property_name": "Valley Park Apartments",
  "property_website_url": "https://www.livevalleypark.com/",
  "property_domain": "https://www.livevalleypark.com/",
  "property_address": "2252A Catasauqua Road",
  "property_full_address": "2252A Catasauqua Rd, Bethlehem, PA 18018",
  "property_address_1": "2252A Catasauqua Rd",
  "property_address_2": null,
  "property_address_city": "Bethlehem",
  "property_address_state": "PA",
  "property_address_zip_full": "18018",
  "property_address_zip": "18018",
  "property_address_country": "US",
  "property_address_county": "Lehigh County",
  "property_neighborhood_address": "W Bethlehem/W Northampton County",
  "property_address_latitude": "40.6429118",
  "property_address_longitude": "-75.4231832",
  "property_email": "valleypark@aionmanagement.com",
  "property_phone": "(610) 867-7100",
  "property_call_tracking_phone": "888-851-3094",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Valley Park Apartments in Bethlehem, PA, comfort meets convenience. Choose from spacious one and two-bedroom floor plans designed for modern living. Enjoy amenities like a refreshing swimming pool, pet-friendly spaces, and a state-of-the-art fitness center. Your home awaits—check availability or schedule a tour today!",
  "property_long_description": "**Discover Valley Park Apartments in Bethlehem, PA – Your New Home Awaits!**\n\nWelcome to Valley Park Apartments, where modern comfort meets community charm! Nestled in the heart of Bethlehem, PA, our apartment community offers a range of thoughtfully designed floor plans, including one-bedroom and two-bedroom options to suit your lifestyle. Whether you’re looking for a cozy retreat or a spacious living space, we have the perfect apartment for you.\n\nAt Valley Park, we prioritize your comfort and convenience with an array of exceptional amenities. Engage in our resident activities, utilize our online resident portal, or enjoy the convenience of flex rent payments. We know your furry friends are part of the family, which is why we’re proud to be pet-friendly! \n\nSpend sunny days at our refreshing swimming pool or grill up a delicious meal at one of our grilling stations. Our community also features a fitness center, business center, and picnic area, providing you with ample opportunities for relaxation and productivity. Enjoy the convenience of 24-hour emergency maintenance, on-site management, and parking options that include both on-site and off-street amenities.\n\nWith easy access to public transportation and high-speed internet available, living at Valley Park Apartments means being connected to the best that Bethlehem has to offer. Experience upgraded living with our AION renovations, complete with stylish oak cabinets, washer and dryer options, and wall-to-wall carpeting that brings warmth to your home.\n\nDon’t wait to make Valley Park Apartments your new home! Browse our availability or schedule a tour today to experience everything our vibrant community has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-4c32-75c4-9e74-43d83eb546b9.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and white countertops.",
    "public_id": "019fce12-4c32-75c4-9e74-43d83eb546b9",
    "storage_key": "property/6767906449166359/019fce12-4c32-75c4-9e74-43d83eb546b9.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "276",
  "property_year_built": "1965",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.46376811594203",
  "property_admin_fee": "75",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per apartment.",
  "property_pet_policy_description": "Cats and dogs are welcome with no weight limit. Maximum of 2 pets per apartment. One-time non‑refundable fee: $300. Monthly pet rent: $50 for one pet, $75 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://valleyparkbethlehem.loftliving.com/login",
  "property_apply_now_url": "https://www.livevalleypark.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026d-a810-75fe-87f7-9985ae82b0c3.webp",
  "property_primary_logo_media": {
    "alt_text": "Valley Park Apartment Homes logo",
    "public_id": "019d026d-a810-75fe-87f7-9985ae82b0c3",
    "storage_key": "property/6767906449166359/019d026d-a810-75fe-87f7-9985ae82b0c3.webp",
    "width": 432,
    "height": 283
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d0270-2192-742f-bb51-287af682fcc6.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0270-2192-742f-bb51-287af682fcc6",
    "storage_key": "property/6767906449166359/019d0270-2192-742f-bb51-287af682fcc6.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d0270-2d89-7346-9a43-664cd55ccbed.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Valley Park Apartment Homes logo",
    "public_id": "019d0270-2d89-7346-9a43-664cd55ccbed",
    "storage_key": "property/6767906449166359/019d0270-2d89-7346-9a43-664cd55ccbed.webp",
    "width": 432,
    "height": 283
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d0270-350d-7308-a5e5-1343ee985606.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Valley Park Apartment Homes logo",
    "public_id": "019d0270-350d-7308-a5e5-1343ee985606",
    "storage_key": "property/6767906449166359/019d0270-350d-7308-a5e5-1343ee985606.webp",
    "width": 432,
    "height": 283
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "695 - 840",
  "property_sqft_min": "695",
  "property_sqft_max": "840",
  "property_price_range": "1478 - 2013",
  "property_price_min": "1478",
  "property_price_max": "2013",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/ValleyParkApts/",
  "property_instagram_url": "https://www.instagram.com/livevalleypark",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0f2rAjA_xIkRyDqRP1XEEa0",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Furnished+Apartments&find_loc=Catasauqua%2C+PA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Valley Park Apartments",
  "property_home_romance_title": "Love Where You Live: Your Perfect Apartment Awaits",
  "property_home_amenities_blurb": "At Valley Park Apartments in Bethlehem, PA, choose from spacious one and two-bedroom floor plans designed for comfort and convenience. Enjoy a vibrant lifestyle with pet-friendly spaces, a refreshing swimming pool, and engaging resident activities. Your perfect home awaits—immerse yourself in our welcoming community today!",
  "property_home_floorplans_blurb": "Nestled in serene Bethlehem, PA, Valley Park Apartments offers stylish one and two-bedroom layouts designed for comfort and convenience. With modern amenities and inviting spaces, your ideal home awaits. Browse our available apartment homes today and find the perfect floor plan that complements your lifestyle.",
  "property_home_gallery_blurb": "Imagine vibrant living at Valley Park Apartments in Bethlehem, PA, where comfort meets community. Choose from spacious one and two-bedroom floor plans and enjoy top-notch amenities like a refreshing pool, dog park, and fitness center. With flexible rent options and a pet-friendly atmosphere, your ideal lifestyle awaits—picture yourself living here!",
  "property_home_neighborhood_blurb": "At Valley Park Apartments in Bethlehem, PA, you’ll find your perfect escape among thoughtfully designed one- and two-bedroom floor plans. Enjoy easy access to vibrant neighborhood gems like the ArtsQuest Center, Wind Creek Event Center, and scenic parks. Immerse yourself in culture, arts, and adventure just steps from home!",
  "property_home_reviews_blurb": "At Valley Park Apartments in Bethlehem, PA, residents rave about their peaceful, spacious living experience, highlighting the “clean and friendly” atmosphere with “great management” and “superb maintenance response.” Enjoy a community where your comfort is priority—find your perfect home today and see what our residents have to say!",
  "property_neighborhood_blurb": "At Valley Park Apartments in Bethlehem, PA, immerse yourself in a vibrant neighborhood teeming with culture and convenience. With nearby attractions like the ArtsQuest Center at SteelStacks, the picturesque Monocacy Park, and the esteemed Moravian University, your new home perfectly balances relaxation and exploration. Dive into local arts, parks, and educational opportunities!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Valley Park Apartments in Bethlehem, PA, vibrant living meets modern convenience. Enjoy spacious one- and two-bedroom layouts, a pet-friendly atmosphere, and an array of amenities, including a fitness center, refreshing swimming pool, and BBQ grilling stations. Discover your perfect home in a community designed for your lifestyle!",
  "property_applynow_blurb": "At Valley Park Apartments in Bethlehem, PA, your perfect home awaits with spacious one- and two-bedroom floor plans. Enjoy pet-friendly living, a refreshing swimming pool, and engaging resident activities, all complemented by modern amenities like high-speed internet and a 24-hour maintenance team. Lease online today for a vibrant community experience!",
  "property_contactus_blurb": "At Valley Park Apartments in Bethlehem, PA, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Experience comfort and convenience in our charming community, where your perfect home awaits. Have questions? Our leasing team is ready to assist you—reach out today!",
  "property_faqs_blurb": "At Valley Park Apartments in Bethlehem, PA, your perfect home awaits! Choose from spacious one and two-bedroom floor plans designed for modern living. Dive into our FAQs page for insights on community life, amenities, and more to ensure you feel right at home. Your next chapter begins here!",
  "property_floorplans_blurb": "At Valley Park Apartments in Bethlehem, PA, your dream home awaits. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored to fit your lifestyle. Each space offers comfort and style, perfect for creating lasting memories. Browse our available apartment homes and find the ideal layout for you today!",
  "property_gallery_blurb": "At Valley Park Apartments in Bethlehem, PA, vibrant living meets modern comfort. Choose from stylish one and two-bedroom floor plans, complete with essential amenities like a sparkling swimming pool, pet-friendly spaces, and inviting grilling stations. Picture yourself savoring life in our community - your dream home awaits!",
  "property_interactivemap_blurb": "At Valley Park Apartments in Bethlehem, PA, you'll find the perfect blend of comfort and convenience. Choose from stylish one- and two-bedroom floor plans, enjoy resident activities, and relax by the pool. With flexible rent payments and a pet-friendly environment, your ideal home awaits. Use our interactive community map to start your journey today!",
  "property_pets_blurb": "At Valley Park Apartments in the heart of Bethlehem, PA, your furry friends are part of the family! Enjoy spacious living with no weight limits for your pets—bring along your two companions for just a small fee. Embrace a community where comfort and companionship thrive!",
  "property_referafriend_blurb": "At Valley Park Apartments in Bethlehem, PA, great friends make great neighbors! With spacious one and two-bedroom floor plans, you’ll find the perfect home to share. Refer a friend today and experience the joy of community living together! Enjoy vibrant surroundings and create lasting memories at Valley Park.",
  "property_residentaccess_blurb": "At Valley Park Apartments in Bethlehem, PA, our spacious one- and two-bedroom floor plans cater to your lifestyle needs. Enjoy seamless living with easy access to our resident portal—pay rent, schedule maintenance, and more—all from the comfort of your home. Connect with your community today!",
  "property_reviews_blurb": "At Valley Park Apartments in Bethlehem, PA, residents rave about their experience, noting, \"Everything you need is nearby... the house itself is clean and spacious.\" With friendly staff, timely maintenance, and a peaceful ambiance, it's no wonder our community earns top ratings. Experience the comfort and convenience yourself!",
  "property_created_at": "1757012691512",
  "property_scheduletour_blurb": "At Valley Park Apartments in Bethlehem, PA, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour and see what our residents love about their vibrant living experience in our welcoming community!",
  "property_thankyou_blurb": "Thank you for reaching out to Valley Park Apartments in Bethlehem, PA! Your interest in our spacious one and two-bedroom floor plans is appreciated. A dedicated team member will connect with you soon to guide you toward your new home in our vibrant community. Stay tuned for more details!",
  "property_virtualtours_blurb": "Welcome to Valley Park Apartments in Bethlehem, PA, where stylish one- and two-bedroom floor plans meet modern comfort. Experience the vibrant community and charming amenities that await you. Ready for a closer look? Take a virtual tour of our inviting spaces and see your new home come to life!",
  "property_copyright": "2025 All Rights Reserved. Valley Park Apartments",
  "property_seo_title_home": "Valley Park Apartments |  Apartments in Bethlehem, PA",
  "property_seo_description_home": "Discover Valley Park Apartments in Bethlehem, PA! Choose from spacious one and two-bedroom units and enjoy premium amenities. Find your home today!",
  "property_seo_title_floorplans": "Floor Plans | Bethlehem, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Valley Park Apartments in Bethlehem, PA. From cozy one-bedrooms to spacious two-bedrooms, browse our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Bethlehem, PA Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort and convenience at Valley Park Apartments in Bethlehem, PA. Enjoy pet-friendly living, fitness facilities, and a relaxing poolside oasis!",
  "property_seo_title_gallery": "Gallery | Apartments in Bethlehem, PA",
  "property_seo_description_gallery": "Discover modern living at Valley Park Apartments in Bethlehem, PA! Enjoy amenities like a pool, fitness center, and dog park. Your ideal home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Valley Park Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Valley Park Apartments in Bethlehem, PA! Enjoy spacious one and two-bedroom designs. Take a virtual tour today and envision your new home!",
  "property_seo_title_interactivemap": "Interactive Map | Valley Park Apartments Apartments",
  "property_seo_description_interactivemap": "Explore Valley Park Apartments! Use our interactive map to find pet-friendly homes and amenities in Bethlehem, PA. Discover your perfect fit!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bethlehem, PA",
  "property_seo_description_neighborhood": "Uncover the charm of Bethlehem, PA! Valley Park Apartments offers vibrant neighborhoods, local hotspots, and inviting spaces—your perfect home awaits!",
  "property_seo_title_contact": "Contact Us | Valley Park Apartments",
  "property_seo_description_contact": "Discover Valley Park Apartments in Bethlehem, PA! Choose from stylish one or two-bedroom plans. Questions? Contact our friendly leasing team!",
  "property_seo_title_faqs": "FAQs | Apartments in Bethlehem, PA",
  "property_seo_description_faqs": "Find answers to your burning questions about Valley Park Apartments in Bethlehem, PA. From amenities to leasing info, we've got you covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bethlehem, PA",
  "property_seo_description_reviews": "Experience life at Valley Park Apartments in Bethlehem, PA! Hear from our residents about community activities, amenities, and the joy of calling us home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Bethlehem, PA",
  "property_seo_description_applynow": "Find your ideal home at Valley Park Apartments in Bethlehem, PA. With modern amenities, pet-friendly options, and flexible leases, comfort awaits! Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Valley Park Apartments",
  "property_seo_description_residentaccess": "Access your Valley Park Apartments resident portal in Bethlehem, PA. Pay rent, schedule maintenance, and manage your home with ease—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Valley Park Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors at Valley Park Apartments! Refer a friend and enjoy vibrant living in Bethlehem, PA, with perks for both of you!",
  "property_seo_title_scheduletour": "Schedule a Tour | Valley Park Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Valley Park Apartments in Bethlehem, PA. Schedule a tour today and envision your new life in our inviting community!",
  "property_seo_title_privacy": "Privacy Policy | Valley Park Apartments",
  "property_seo_description_privacy": "At Valley Park Apartments, safeguarding your data is our priority. Check our privacy policy for full transparency!",
  "property_seo_title_accessibility": "Website Accessibility | Valley Park Apartments",
  "property_seo_description_accessibility": "Discover Valley Park Apartments in Bethlehem, PA—a welcoming community prioritizing digital inclusion for everyone to thrive in comfort and accessibility.",
  "property_seo_title_sitemap": "Sitemap | Valley Park Apartments",
  "property_seo_description_sitemap": "Uncover the heart of Valley Park Apartments in Bethlehem, PA. Navigate easily with our sitemap and find your dream home today!",
  "property_seo_title_thankyou": "Thank You | Valley Park Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in Valley Park Apartments in Bethlehem, PA, is appreciated. Our team will connect with you soon to assist!",
  "property_seo_title_pets": "Pet Policy | Apartments in Bethlehem, PA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293568272",
  "amenities": [
    {
      "id": "custom_3baff867-3954-44b0-b1f4-35f0719851e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69d4ce78-d7bd-4643-b2e3-34096bd8d86f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_01e0578d-6abf-4a0b-96ba-ce2a49c387ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_092dcf93-704c-4e16-a678-cc77c74b918a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da32df99-9abd-41f2-9fa0-c19e6b9650cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Wi-Fi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_103a2a40-195d-4a44-9c06-c9f29925c2a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b2a1ede-e8da-4fc3-ace3-390944db4881",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df6efe55-12c8-4b8c-aab6-be97baff0416",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bdc6e633-715b-40ac-85a9-904f0ba1d601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f419eef7-60af-47f0-bbf8-e5f84cffb131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e791737-b941-41b9-a457-2119145e3160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Apartments Available*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2991d50a-4d4f-4e36-a627-03d6602a8ca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer & Dryer*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6478235c-92ed-4ada-93eb-cd8f28a53270",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dd673f02-4251-446f-aeac-d62e938f7e22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3d2a1df-101b-4d07-a27b-56a8f44a6c94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_995cc7f1-8b33-496f-a7c5-d7d2295a24de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc92176a-b75d-4e1c-b94e-7c6680586932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Plank Flooring*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e20253b3-8a23-4b0c-a5ea-482e69f06fcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06ab00b4-dd8d-4026-89ba-0e5379cae199",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5dcac10-e0d0-4d3f-8ad0-d2667c8093cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b56b80ac-af31-482d-99da-6d4d224efa63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fcd16cf3-fd82-40c2-a875-ca20a1b220c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Cable-Ready",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e3d9b872-35c5-4051-8e33-bb75f6a442c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Wall-to-Wall Carpet",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_460a8d9c-5e63-4323-817e-0b7fbf59360f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Nearby Shopping, Schools, & Major Highways",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_969d4e10-1ee5-4c77-913d-53bdea151adc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b51a8fb-d482-4673-8c3f-8abff101e41b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "30 Acres of Mature Landscaped Grounds",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b9f6c5b-cf32-44cf-be71-e1ceff95b7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ae6059a-b67a-4413-a4f9-eb35ae813a9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_747969f1-4223-4e4a-bb46-de3a15196511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Pavilion",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9d060d6-fba8-4ef2-bdba-476c18bdc308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_f993285d-b3f9-4746-887a-22232a519274",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-5a55-763d-babb-ad29dde5fed5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, subway tile backsplash, and granite countertops.",
        "public_id": "019fce12-5a55-763d-babb-ad29dde5fed5",
        "storage_key": "property/6767906449166359/019fce12-5a55-763d-babb-ad29dde5fed5.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring dark wood cabinetry, stainless steel appliances including a refrigerator, dishwasher, oven, and microwave, complemented by a stylish subway tile backsplash and granite countertops.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and a white subway tile backsplash.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/dc3b9cc226765947d3acf2d7f4bb5053-5a3df1d4.jpg"
    },
    {
      "id": "custom_74db9476-c8d2-4e7b-8bbc-3a88e9627aa1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-5a35-7656-b3cc-6bb6924296f2.webp",
      "image_media": {
        "alt_text": "Living room with sofa, armchair, coffee table, and dining area visible.",
        "public_id": "019fce12-5a35-7656-b3cc-6bb6924296f2",
        "storage_key": "property/6767906449166359/019fce12-5a35-7656-b3cc-6bb6924296f2.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Comfortable and spacious living room featuring a plush sofa, accent armchair, and a modern coffee table, perfect for relaxation and entertaining. Enjoy views of the outdoors through the sliding glass door.",
      "link": "false",
      "alt_text": "Living room with two beige sofas, a round concrete coffee table, and a sliding glass door to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/dacc65043d3bacb6af56411bf484c7bd-abc6582d.jpg"
    },
    {
      "id": "custom_6f9239ab-e7ef-44b7-b06f-03716af2d754",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-5a1a-736a-a997-ae792fdd668f.webp",
      "image_media": {
        "alt_text": "Dining area with round table and chairs, adjacent to kitchen with refrigerator.",
        "public_id": "019fce12-5a1a-736a-a997-ae792fdd668f",
        "storage_key": "property/6767906449166359/019fce12-5a1a-736a-a997-ae792fdd668f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Cozy dining area in a modern apartment featuring a round table, four chairs, a ceiling fan, and natural light from a window.",
      "link": "false",
      "alt_text": "Small apartment dining nook with a round table, four chairs, a ceiling fan, and window blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/43ebf41efdaff498b54b12027dcb6ece-11fdccf0.jpg"
    },
    {
      "id": "custom_d3f85f3a-831e-4738-9f3a-d03eefa01451",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-5a49-778b-9096-d0c36d9c4b8f.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-size bed, dresser, and bookshelf.",
        "public_id": "019fce12-5a49-778b-9096-d0c36d9c4b8f",
        "storage_key": "property/6767906449166359/019fce12-5a49-778b-9096-d0c36d9c4b8f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, contemporary bedroom featuring a plush bed, decorative shelving, and a sleek dresser beneath a wall-mounted TV.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a bed, white ladder bookshelf, and a dresser under a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/23cf2ced8e43cc7550d56c14db77d8e7-4d51e206.jpg"
    },
    {
      "id": "custom_c537dc9e-a4a1-4ae9-b7b2-659a2293f47a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-65b0-72bd-921f-032f175c0b78.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019fce12-65b0-72bd-921f-032f175c0b78",
        "storage_key": "property/6767906449166359/019fce12-65b0-72bd-921f-032f175c0b78.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright, modern apartment kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and white countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/88b2fb491e7b1f859bb8cb9909f9387f-2c69b1c4.jpg"
    },
    {
      "id": "custom_6dc20e99-0773-43c8-b38f-51388baef127",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-6677-74df-bb57-66b78cd8baf2.webp",
      "image_media": {
        "alt_text": "Professionally staged bedroom with a queen-size bed, dresser, and window.",
        "public_id": "019fce12-6677-74df-bb57-66b78cd8baf2",
        "storage_key": "property/6767906449166359/019fce12-6677-74df-bb57-66b78cd8baf2.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully staged bedroom, featuring a comfortable queen-size bed, ample dresser space, and plenty of natural light from the large window.",
      "link": "false",
      "alt_text": "Furnished apartment bedroom with a bed, dresser, chair, and window air conditioner.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/f31832d61cf0797154fa7d76b9bb6448-cf45ec78.jpg"
    },
    {
      "id": "custom_d2595a59-ab1e-4312-9f3e-9ceeb9b88281",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-6690-732c-a46b-e749c5559f9c.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a white sink, chrome faucet, and a mirrored medicine cabinet.",
        "public_id": "019fce12-6690-732c-a46b-e749c5559f9c",
        "storage_key": "property/6767906449166359/019fce12-6690-732c-a46b-e749c5559f9c.webp",
        "width": 890,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a single-sink vanity, mirrored cabinet, and simple accessories.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, mirror cabinet, and a bright three-light fixture.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/3d82a4ce329387a170be1eea8a690027-2993bdf0.jpg"
    },
    {
      "id": "custom_213eff6f-073b-4c34-9f43-eb996b0e747b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-70e6-70dd-bb90-24fbd5b088ce.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fce12-70e6-70dd-bb90-24fbd5b088ce",
        "storage_key": "property/6767906449166359/019fce12-70e6-70dd-bb90-24fbd5b088ce.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with dark cabinets, white tile backsplash, and stainless steel appliances.",
      "link": "false",
      "alt_text": "Compact kitchen with dark wood cabinets and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/ffd078eb15a0f0f85a81e1e3a4171cf9-7b5e76d1.jpg"
    },
    {
      "id": "custom_9e780e53-5066-4d48-b1f9-3bef5938d087",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-7140-7319-8214-ac1655f5974e.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with white cabinets, stainless steel appliances, and a dining table.",
        "public_id": "019fce12-7140-7319-8214-ac1655f5974e",
        "storage_key": "property/6767906449166359/019fce12-7140-7319-8214-ac1655f5974e.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Open-concept apartment with a white kitchen, dining table, and a comfortable living area with a TV.",
      "link": "false",
      "alt_text": "Open-concept kitchen with white cabinets, fridge, stove, and adjacent dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/3c372adce7d0f889c485983cf768b92b-588129f2.jpg"
    },
    {
      "id": "custom_64e4c37d-8448-42e1-a739-385ff930ff1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-7787-76d1-8da7-953e314aef14.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sofa, coffee table, TV, and decorative shelf.",
        "public_id": "019fce12-7787-76d1-8da7-953e314aef14",
        "storage_key": "property/6767906449166359/019fce12-7787-76d1-8da7-953e314aef14.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Contemporary apartment living area with a large flat-screen TV, minimalist shelving, and neutral decor.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a gray sectional sofa and large TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/431d915ad88bb01fedbfe9c10530327c-09350285.jpg"
    },
    {
      "id": "custom_c0468c3a-dbf1-403f-a5dc-c899520fd59c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-7c8e-761f-ac05-06a7e73a2c15.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dark wood vanity, white countertop, sink, toilet, and a shower with a black curtain.",
        "public_id": "019fce12-7c8e-761f-ac05-06a7e73a2c15",
        "storage_key": "property/6767906449166359/019fce12-7c8e-761f-ac05-06a7e73a2c15.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a white countertop, dark wood vanity, and a tub/shower with a black-gray curtain.",
      "link": "false",
      "alt_text": "Bathroom with a white countertop sink, dark wood vanity, toilet, and a tub/shower with a black-gray curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/3a7731c64e7f4222f25c4c53839fe82a-006c20f0.jpg"
    },
    {
      "id": "custom_07e4b6f9-3a7d-443d-b95a-d555b8d5d79f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-7dc6-776b-896c-3fe0a4df9a21.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dark vanity, white sink, chrome faucet, and a large mirror.",
        "public_id": "019fce12-7dc6-776b-896c-3fe0a4df9a21",
        "storage_key": "property/6767906449166359/019fce12-7dc6-776b-896c-3fe0a4df9a21.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a tub/shower, white tile surround, and a dark wood vanity.",
      "link": "false",
      "alt_text": "Bathroom with tub/shower, toilet, and dark wood vanity with a mirrored cabinet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/e994b210a40a969693fa7d829d376a30-b5a1a24b.jpg"
    },
    {
      "id": "custom_1abd1316-9915-45c5-acfd-1a2e35d8517a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-836b-73ba-9354-3ac6c2fd3e95.webp",
      "image_media": {
        "alt_text": "Covered picnic pavilion with grills and seating area in a grassy park.",
        "public_id": "019fce12-836b-73ba-9354-3ac6c2fd3e95",
        "storage_key": "property/6767906449166359/019fce12-836b-73ba-9354-3ac6c2fd3e95.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community picnic pavilion, complete with grills and ample seating.",
      "link": "false",
      "alt_text": "Wooden pavilion with picnic tables and grills in a grassy park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/3558a86957e88035bbd51185f1006cd4-fe9eef16.jpg"
    },
    {
      "id": "custom_29d4e8d3-568f-4604-a6bc-6d06f96403cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-8837-701e-8558-80a089c2023f.webp",
      "image_media": {
        "alt_text": "Dog running in a fenced-in grassy area.",
        "public_id": "019fce12-8837-701e-8558-80a089c2023f",
        "storage_key": "property/6767906449166359/019fce12-8837-701e-8558-80a089c2023f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "A brown dog runs in a lush, fenced community yard, showcasing outdoor amenities for residents.",
      "link": "false",
      "alt_text": "A brown dog runs across a green lawn inside a chain-link fenced area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/60960482808bf893f5587c8820b43575-49ede617.jpg"
    },
    {
      "id": "custom_f2206fe3-0e98-4f25-9170-45c0e9ab9efa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-8bc4-71fa-95ab-77a4a7ecedba.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and seating areas",
        "public_id": "019fce12-8bc4-71fa-95ab-77a4a7ecedba",
        "storage_key": "property/6767906449166359/019fce12-8bc4-71fa-95ab-77a4a7ecedba.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor pool area for residents featuring dining tables, chairs, blue umbrellas, and surrounding green landscaping.",
      "link": "false",
      "alt_text": "Outdoor apartment community pool area with seating and blue umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/ddc68581c2ee612585154334f8e13440-a77bf685.jpg"
    },
    {
      "id": "custom_7a23c81a-4b35-4e08-9396-2c35bd7a1375",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-8d5f-754a-a156-d5907c0be936.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by lush greenery.",
        "public_id": "019fce12-8d5f-754a-a156-d5907c0be936",
        "storage_key": "property/6767906449166359/019fce12-8d5f-754a-a156-d5907c0be936.webp",
        "width": 1920,
        "height": 1396
      },
      "title": "Community",
      "description": "Poolside community amenity with a large pool, lounge seating, and shaded tables.",
      "link": "false",
      "alt_text": "Outdoor pool area with blue umbrellas, lounge chairs, and tables among green trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/dfb7db9bb00cb660dd1c5c6c30b7ba7f-92654749.jpg"
    },
    {
      "id": "custom_63aaada0-cee4-4301-93a0-cccf42d00d99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-9035-7038-a494-51405eae1f80.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and stationary bikes.",
        "public_id": "019fce12-9035-7038-a494-51405eae1f80",
        "storage_key": "property/6767906449166359/019fce12-9035-7038-a494-51405eae1f80.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with modern cardio machines to help you stay active and healthy.",
      "link": "false",
      "alt_text": "Bright apartment gym with treadmills, ellipticals, and stationary bikes beside large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/f38c1a11f3e93ecfbb2c6078da503c61-bcbcdc4f.jpg"
    },
    {
      "id": "custom_fc9edde9-bb49-4554-aecf-e7345495c7aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-96da-756d-bb44-8f1914a26eeb.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, treadmills, and dumbbells.",
        "public_id": "019fce12-96da-756d-bb44-8f1914a26eeb",
        "storage_key": "property/6767906449166359/019fce12-96da-756d-bb44-8f1914a26eeb.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "Fully equipped community gym with cardio machines, free weights, and a wall-mounted TV.",
      "link": "false",
      "alt_text": "Indoor fitness center with treadmills, elliptical machines, weights, and a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/0a62f174c7c1d61eb2653185a430bcfc-9985c2f0.jpg"
    },
    {
      "id": "custom_a559ea7e-14e0-4d07-b814-e86e9cfa7493",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-973f-7062-90dc-c5483f14a303.webp",
      "image_media": {
        "alt_text": "Gym with weights, benches, medicine balls, and yoga mats.",
        "public_id": "019fce12-973f-7062-90dc-c5483f14a303",
        "storage_key": "property/6767906449166359/019fce12-973f-7062-90dc-c5483f14a303.webp",
        "width": 1920,
        "height": 1451
      },
      "title": "Community",
      "description": "On-site community gym featuring free weights, a weight rack, adjustable benches, and a wall TV for workouts.",
      "link": "false",
      "alt_text": "Well-lit community fitness room with free weights, benches, and a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/cd805c695dbd35f0f5bfd6ac732fd426-84af2bca.jpg"
    },
    {
      "id": "custom_725645f1-491d-4dde-b3c0-ea21fbb7c020",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-999d-74e4-8aad-8eb5f4a85dcf.webp",
      "image_media": {
        "alt_text": "Barbecue grills with hot dogs and burgers on a grassy lawn with a picnic table in the background.",
        "public_id": "019fce12-999d-74e4-8aad-8eb5f4a85dcf",
        "storage_key": "property/6767906449166359/019fce12-999d-74e4-8aad-8eb5f4a85dcf.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor community grilling area at a multifamily property with several grills and a nearby picnic table.",
      "link": "false",
      "alt_text": "Outdoor community grills on a grassy lawn with a picnic table in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/72bb6c07b45f7abb0ba1729b15bf4335-9a098e52.jpg"
    },
    {
      "id": "custom_b3a9c41a-1b2b-44f6-b538-6b524585e8a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-9bf2-764b-8a00-1a3cafddde8a.webp",
      "image_media": {
        "alt_text": "Picnic table with hot dogs and burgers, set up on grass with grills in the background.",
        "public_id": "019fce12-9bf2-764b-8a00-1a3cafddde8a",
        "storage_key": "property/6767906449166359/019fce12-9bf2-764b-8a00-1a3cafddde8a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Sunny outdoor community space with grills and a picnic table set for gatherings.",
      "link": "false",
      "alt_text": "Outdoor community picnic area with grills and a wooden table set for a meal.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/2aaf1be622bc5c2319bdabf6cbe88c65-81903092.jpg"
    },
    {
      "id": "custom_331cab07-6a4f-485f-b51a-95d841515711",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-a280-71ab-8069-a6d182f8d65c.webp",
      "image_media": {
        "alt_text": "Aerial view of historic brick buildings surrounded by lush green trees under a clear blue sky.",
        "public_id": "019fce12-a280-71ab-8069-a6d182f8d65c",
        "storage_key": "property/6767906449166359/019fce12-a280-71ab-8069-a6d182f8d65c.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Bird's-eye view of a brick apartment community with green spaces and interconnected buildings.",
      "link": "false",
      "alt_text": "Aerial view of a brick building complex with lush trees and a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/6b9c390473758520db5121114097a79d-68681df3.jpg"
    },
    {
      "id": "custom_2e661cc7-7b5e-4fc1-8aa0-b94bf27ed066",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-a2e8-724e-b8d1-bebb482da193.webp",
      "image_media": {
        "alt_text": "Brick apartment building with manicured lawns and mature trees.",
        "public_id": "019fce12-a2e8-724e-b8d1-bebb482da193",
        "storage_key": "property/6767906449166359/019fce12-a2e8-724e-b8d1-bebb482da193.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Charming brick apartment building with pristine landscaping, inviting walkways, and lush green lawns, offering a serene community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with a green lawn, trees, and small entry porches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/0f431e75609bacb308d70b46b60d0de0-38300662.jpg"
    },
    {
      "id": "custom_dd3da743-93fe-4469-9db5-d8e343624cf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-a685-7068-a020-8b043e1e6518.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with a green roof over the entrance.",
        "public_id": "019fce12-a685-7068-a020-8b043e1e6518",
        "storage_key": "property/6767906449166359/019fce12-a685-7068-a020-8b043e1e6518.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a brick multifamily community featuring a central entryway and landscaped grounds.",
      "link": "false",
      "alt_text": "Brick apartment building exterior with central entry, white columns, and manicured lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/8c3b6d37fc5f0a43e0b245baeb0e1f36-4188a421.jpg"
    },
    {
      "id": "custom_38ccb99e-50be-463e-8c0f-68993c4d8f09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-a81f-75ff-9d10-8b776e69170a.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking a green lawn and trees. Two wicker chairs are on the balcony.",
        "public_id": "019fce12-a81f-75ff-9d10-8b776e69170a",
        "storage_key": "property/6767906449166359/019fce12-a81f-75ff-9d10-8b776e69170a.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Balcony seating overlooking a lush, tree-filled courtyard with green lawn and distant buildings.",
      "link": "false",
      "alt_text": "Balcony with wicker chairs overlooks a grassy, tree-filled courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/340eb4f7/dms3rep/multi/24d6aeaa61edcaa7fddbd804d54d4895-f2aa8fa3.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_35054dd0-f066-4f28-9645-0f4a75dd91be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Bolete",
      "poi_type": "Restaurants",
      "poi_address": "1740 Seidersville Rd, Bethlehem, PA 18015, USA",
      "poi_short_description": "Rustic-chic destination serving a seasonal farm-to-table menu of American cuisine, with a full bar.",
      "poi_long_description": "Rustic-chic destination serving a seasonal farm-to-table menu of American cuisine, with a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-b795-72c1-ba21-41f75ca2f6c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-b795-72c1-ba21-41f75ca2f6c2",
        "storage_key": "property/6767906449166359/019fce12-b795-72c1-ba21-41f75ca2f6c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.boleterestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13450884497375636781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bolete",
      "poi_latitude": "40.5946965",
      "poi_longitude": "-75.4118034",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-868-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhabH26E-xIkRLS3iPC8kq7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_188251ac-44a5-4ba7-a710-21cef1c7f5c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Thai Thai II",
      "poi_type": "Restaurants",
      "poi_address": "509 Main St, Bethlehem, PA 18018, USA",
      "poi_short_description": "Curries, noodles & rolls are among the options at this basic Thai spot with a casual setting.",
      "poi_long_description": "Curries, noodles & rolls are among the options at this basic Thai spot with a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-b77d-7055-b855-cd5870da0be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-b77d-7055-b855-cd5870da0be2",
        "storage_key": "property/6767906449166359/019fce12-b77d-7055-b855-cd5870da0be2.webp",
        "width": 960,
        "height": 541
      },
      "poi_business_url": "http://thaithai2.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9475921320447724156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thai-thai-ii",
      "poi_latitude": "40.6208945",
      "poi_longitude": "-75.3821691",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-868-1919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSJSyVY-xIkRfErWQDw8gYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e840e398-c135-46ba-96cd-d53999a74935",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Tapas On Main",
      "poi_type": "Restaurants",
      "poi_address": "500 Main St, Bethlehem, PA 18018, USA",
      "poi_short_description": "Airy indoor/outdoor eatery serving Spanish tapas & sangria with occasional live music.",
      "poi_long_description": "Airy indoor/outdoor eatery serving Spanish tapas & sangria with occasional live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-b777-7411-8747-c417e485df21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-b777-7411-8747-c417e485df21",
        "storage_key": "property/6767906449166359/019fce12-b777-7411-8747-c417e485df21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tapasonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5655640719558273981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tapas-on-main",
      "poi_latitude": "40.6207479",
      "poi_longitude": "-75.3818199",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-868-8903",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ10N1M1E-xIkRvWuBAkXffE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f92d9ee2-ae52-416a-9949-f7af36452bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Apollo Grill",
      "poi_type": "Restaurants",
      "poi_address": "85 W Broad St, Bethlehem, PA 18018, USA",
      "poi_short_description": "Cozy, refined bar & grill featuring an extensive appetizer menu, full bar & American entrees.",
      "poi_long_description": "Cozy, refined bar & grill featuring an extensive appetizer menu, full bar & American entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-b7cd-7738-a65c-66131b782c8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-b7cd-7738-a65c-66131b782c8f",
        "storage_key": "property/6767906449166359/019fce12-b7cd-7738-a65c-66131b782c8f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.apollogrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7837805465488128931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apollo-grill",
      "poi_latitude": "40.6222147",
      "poi_longitude": "-75.381241",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 610-865-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c36c-76c6-944c-a63a12b6f3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c36c-76c6-944c-a63a12b6f3f3",
        "storage_key": "property/6767906449166359/019d026e-c36c-76c6-944c-a63a12b6f3f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN4UHWFE-xIkRo_sIXYt6xWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c80d5003-abf9-4350-8584-89c4121aebdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Fegley's Bethlehem Brew Works",
      "poi_type": "Restaurants",
      "poi_address": "559 Main St #101, Bethlehem, PA 18018, USA",
      "poi_short_description": "Restaurant & brewery offering beers & hearty pub grub in an airy, industrial space.",
      "poi_long_description": "Restaurant & brewery offering beers & hearty pub grub in an airy, industrial space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-bd8d-71bf-80ed-955f3c512568.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-bd8d-71bf-80ed-955f3c512568",
        "storage_key": "property/6767906449166359/019fce12-bd8d-71bf-80ed-955f3c512568.webp",
        "width": 1267,
        "height": 1280
      },
      "poi_business_url": "https://www.thebrewworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2121624635793940899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fegleys-bethlehem-brew-works",
      "poi_latitude": "40.622284",
      "poi_longitude": "-75.3821372",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-882-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySvFqlY-xIkRoyE3i12GcR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db31c620-3171-4998-b20d-3ca65eedd40c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Edge Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "74 W Broad St Suite 220, Bethlehem, PA 18018, USA",
      "poi_short_description": "Artfully presented modern fare with Asian & French influences in an upscale, contemporary space.",
      "poi_long_description": "Artfully presented modern fare with Asian & French influences in an upscale, contemporary space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-be72-71f9-82b4-a8d131717347.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-be72-71f9-82b4-a8d131717347",
        "storage_key": "property/6767906449166359/019fce12-be72-71f9-82b4-a8d131717347.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.edgerestaurant.net/?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_content=website_button",
      "poi_directions_map_url": "https://maps.google.com/?cid=7371037667339414600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edge-restaurant",
      "poi_latitude": "40.6227176",
      "poi_longitude": "-75.3814549",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-814-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXQW-1M-xIkRSCzKe7QvS2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2da56a3-9ac6-4385-986a-7845b240da6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Dom's Westgate Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2335 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "Relaxed eatery specializing in NY-style pies along with classic Italian eats, hot subs and cheese steaks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-bed6-7338-8cb0-01677f1c63b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-bed6-7338-8cb0-01677f1c63b9",
        "storage_key": "property/6767906449166359/019fce12-bed6-7338-8cb0-01677f1c63b9.webp",
        "width": 1280,
        "height": 804
      },
      "poi_business_url": "http://www.westgatepizzarestaurant.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10507453050211011329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doms-westgate-pizza",
      "poi_latitude": "40.6418962",
      "poi_longitude": "-75.4033809",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-865-1393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTWub5RA_xIkRAQvs1-D40ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1076e5cf-86be-4171-8b23-b8ff1a4b116c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Jersey Mike's Subs",
      "poi_type": "Restaurants",
      "poi_address": "2415 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_long_description": "New Jersey–based counter-serve sandwich chain serving jumbo subs filled with cold cuts & toppings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-be9d-7790-af0d-a50b812d6fdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-be9d-7790-af0d-a50b812d6fdb",
        "storage_key": "property/6767906449166359/019fce12-be9d-7790-af0d-a50b812d6fdb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.jerseymikes.com/8082/bethlehem-pa",
      "poi_directions_map_url": "https://maps.google.com/?cid=4552681365561327782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-mikes-subs",
      "poi_latitude": "40.6425067",
      "poi_longitude": "-75.4037827",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 484-635-1782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtfbfNAA_xIkRpsDSsZRfLj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5070428f-26d5-4849-8f13-b910dee12dca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "2417 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-c416-747b-8a57-af972ccf9c09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-c416-747b-8a57-af972ccf9c09",
        "storage_key": "property/6767906449166359/019fce12-c416-747b-8a57-af972ccf9c09.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.qdoba.com/us/pa/bethlehem/2417-schoenersville-rd?utm_medium=organic&utm_source=google&utm_campaign=1279_2024_all_seo_google_maps_local&utm_content=website&utm_term=3048",
      "poi_directions_map_url": "https://maps.google.com/?cid=11611122519428615482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "40.64255",
      "poi_longitude": "-75.40382799999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 484-353-6533",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJox0p0A4_xIkROs0Uvmn-IqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07240840-4952-4f7f-ad44-df9239f8f150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "2409 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-c50e-70ea-a399-12fdee97a610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-c50e-70ea-a399-12fdee97a610",
        "storage_key": "property/6767906449166359/019fce12-c50e-70ea-a399-12fdee97a610.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.starbucks.com/store-locator?map=40.657455,-75.379605,10z&place=18017",
      "poi_directions_map_url": "https://maps.google.com/?cid=14591126097449244419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "40.64275",
      "poi_longitude": "-75.40512",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-578-2576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c362-7719-8d36-2e86bedb2846.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c362-7719-8d36-2e86bedb2846",
        "storage_key": "property/6767906449166359/019d026e-c362-7719-8d36-2e86bedb2846.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHdj6Cco_xIkRA9dk5-AXfso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0538c8ea-f08b-43c9-891c-2e5265029b06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Mis Raíces Restaurant & Bakery",
      "poi_type": "Restaurants",
      "poi_address": "2915 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "Casual, kid-friendly joint for traditional Colombian dishes such as sancocho, empanadas and bandeja paisa.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-c55c-73f3-b5b4-ae94909aa98b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-c55c-73f3-b5b4-ae94909aa98b",
        "storage_key": "property/6767906449166359/019fce12-c55c-73f3-b5b4-ae94909aa98b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://misraicesbelen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3910458378033069716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mis-races-restaurant--bakery",
      "poi_latitude": "40.6490843",
      "poi_longitude": "-75.4104815",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-419-0461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_Wf0p8_xIkRlH6cIy29RDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aabe4c1f-f891-460a-b0f5-1882b2bd4b8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Reunion Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2915 Schoenersville Rd # 3, Bethlehem, PA 18017, USA",
      "poi_short_description": "Chinese comfort food, including shrimp and General Tso's chicken, available for takeout or delivery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-c5b1-7283-877e-8f4794d794fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-c5b1-7283-877e-8f4794d794fd",
        "storage_key": "property/6767906449166359/019fce12-c5b1-7283-877e-8f4794d794fd.webp",
        "width": 1280,
        "height": 932
      },
      "poi_business_url": "http://www.reunioneatery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4860061319343539137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "reunion-chinese-restaurant",
      "poi_latitude": "40.64912899999999",
      "poi_longitude": "-75.410539",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-807-0671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZn1bxU_xIkRwYMWLgVockM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f21461f6-a356-4e05-9808-32938e9be9f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Beef Baron",
      "poi_type": "Restaurants",
      "poi_address": "2366 Catasauqua Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Cozy bar and grill in Shoppers Village offering comfort food, beer, and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-c9ec-7761-a5fd-ffb61c3630b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-c9ec-7761-a5fd-ffb61c3630b1",
        "storage_key": "property/6767906449166359/019fce12-c9ec-7761-a5fd-ffb61c3630b1.webp",
        "width": 640,
        "height": 524
      },
      "poi_business_url": "https://www.facebook.com/the-Beef-Baron-114631418566129/?fref=ts",
      "poi_directions_map_url": "https://maps.google.com/?cid=289224047082245292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beef-baron",
      "poi_latitude": "40.6431101",
      "poi_longitude": "-75.4263534",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 610-868-8995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c36c-76c6-944c-a63a12b6f3f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c36c-76c6-944c-a63a12b6f3f3",
        "storage_key": "property/6767906449166359/019d026e-c36c-76c6-944c-a63a12b6f3f3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xAKLC4_xIkRrIzWCr2HAwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_84821a32-90d2-4501-a6aa-08770553728a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "PrimoHoagies",
      "poi_type": "Restaurants",
      "poi_address": "2410 Catasauqua Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Philly-born counter-serve sandwich chain known for its hefty hoagies built on sesame-seed rolls.",
      "poi_long_description": "Philly-born counter-serve sandwich chain known for its hefty hoagies built on sesame-seed rolls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-cb76-76cd-a228-dae20e6fa3bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-cb76-76cd-a228-dae20e6fa3bd",
        "storage_key": "property/6767906449166359/019fce12-cb76-76cd-a228-dae20e6fa3bd.webp",
        "width": 1280,
        "height": 910
      },
      "poi_business_url": "https://www.primohoagies.com/location/Bethlehem-PA",
      "poi_directions_map_url": "https://maps.google.com/?cid=6739001332620505280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primohoagies",
      "poi_latitude": "40.64349989999999",
      "poi_longitude": "-75.4269214",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 484-895-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrZn1bxU_xIkRwLC62wG-hV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_de3fdd74-41f3-4280-a547-74f95dcc5e4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "The Bayou",
      "poi_type": "Restaurants",
      "poi_address": "702 Hawthorne Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "New Orleans-inspired nook with inventive Southern comfort food & craft brews in a rustic-chic space.",
      "poi_long_description": "New Orleans-inspired nook with inventive Southern comfort food & craft brews in a rustic-chic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-cb05-7000-b579-8388fb9b72e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-cb05-7000-b579-8388fb9b72e8",
        "storage_key": "property/6767906449166359/019fce12-cb05-7000-b579-8388fb9b72e8.webp",
        "width": 738,
        "height": 416
      },
      "poi_business_url": "https://datbayoulv.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=1098982768420900827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bayou",
      "poi_latitude": "40.623047",
      "poi_longitude": "-75.36460819999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-419-6669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcuBfTU-xIkR288AVgFfQA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7f060a4f-9100-4bed-b59f-69a8682aa870",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "1856 Catasauqua Rd, Allentown, PA 18109, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-cc5d-73fa-9eaa-d94a99d23ad4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-cc5d-73fa-9eaa-d94a99d23ad4",
        "storage_key": "property/6767906449166359/019fce12-cc5d-73fa-9eaa-d94a99d23ad4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.aldi.us/pa/allentown/1856-catasauqua-road?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=3078759711014474596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.6389777",
      "poi_longitude": "-75.4299721",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb07-73e1-a1c4-afd55daafca8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb07-73e1-a1c4-afd55daafca8",
        "storage_key": "property/6767906449166359/019d026e-cb07-73e1-a1c4-afd55daafca8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE8mH1yI_xIkRZFPNK6XzuSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8fbfedc1-8250-405a-83ee-4a2c1207b734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "GIANT",
      "poi_type": "Shopping",
      "poi_address": "2174 W Union Blvd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Large grocery store featuring produce, meat, bakery items, deli goods and beer.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-cf99-740c-9055-fb5121a7f88c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-cf99-740c-9055-fb5121a7f88c",
        "storage_key": "property/6767906449166359/019fce12-cf99-740c-9055-fb5121a7f88c.webp",
        "width": 1280,
        "height": 592
      },
      "poi_business_url": "https://stores.giantfoodstores.com/pa/bethlehem/2174-west-union-blvd?y_source=1_NDE5NTQ4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10882934469112087965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giant",
      "poi_latitude": "40.6272224",
      "poi_longitude": "-75.4187018",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-691-4304",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb07-73e1-a1c4-afd55daafca8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb07-73e1-a1c4-afd55daafca8",
        "storage_key": "property/6767906449166359/019d026e-cb07-73e1-a1c4-afd55daafca8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VUrYtk-xIkRncVHST3zB5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0eac3042-c01e-497e-8222-602586d9a4ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping",
      "poi_address": "2434 Catasauqua Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-d11d-700b-89cb-2ccb7f92bc15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-d11d-700b-89cb-2ccb7f92bc15",
        "storage_key": "property/6767906449166359/019fce12-d11d-700b-89cb-2ccb7f92bc15.webp",
        "width": 1280,
        "height": 882
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bethlehem-pa-pharmacies/2434-catasauqua-road-shoppers-village-bethlehem-pa-18018/storeid=1036?WT.mc_id=LS_GOOGLE_FS_1036",
      "poi_directions_map_url": "https://maps.google.com/?cid=5916352017986672235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.643516",
      "poi_longitude": "-75.42728029999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 610-868-5122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfyyAi4_xIkRa9ZCbtAaG1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb344e0b-f777-4aa9-9f15-860e850f66b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping",
      "poi_address": "1866 Catasauqua Rd, Allentown, PA 18109, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-d136-72bb-a8f1-812c98cc2c08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-d136-72bb-a8f1-812c98cc2c08",
        "storage_key": "property/6767906449166359/019fce12-d136-72bb-a8f1-812c98cc2c08.webp",
        "width": 1074,
        "height": 645
      },
      "poi_business_url": "https://stores.dollargeneral.com/pa/allentown/466",
      "poi_directions_map_url": "https://maps.google.com/?cid=16647946869245151408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "40.6393829",
      "poi_longitude": "-75.42987509999999",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-973-7215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-caa5-739b-a2db-e22406db9041",
        "storage_key": "property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJP9zIiiw_xIkRsAjvFHljCec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b757d0cf-0abe-4138-a925-8a9124970f8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Sunoco Gas Station",
      "poi_type": "Shopping",
      "poi_address": "2450 Catasauqua Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Unpretentious establishment with working-class mechanics who take a family-run approach to vehicle tuneups and inspections plus gas pumps.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-d34e-76fb-a36d-7eb3e9c9044d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-d34e-76fb-a36d-7eb3e9c9044d",
        "storage_key": "property/6767906449166359/019fce12-d34e-76fb-a36d-7eb3e9c9044d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sunoco.com/locations/store/2450-catasauqua-st-bethlehem-pa-0006390900?utm_source=gmb&utm_medium=organic&utm_content=8000029101",
      "poi_directions_map_url": "https://maps.google.com/?cid=7981792202065949972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunoco-gas-station",
      "poi_latitude": "40.6434319",
      "poi_longitude": "-75.4279859",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 610-419-8012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-ca95-772d-8735-c0714de7a3b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-ca95-772d-8735-c0714de7a3b1",
        "storage_key": "property/6767906449166359/019d026e-ca95-772d-8735-c0714de7a3b1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7RlJ4zE_xIkRFLUf67cFxW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d0dbca2c-7058-41a3-85ba-eef030ae7ba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping",
      "poi_address": "1885 Catasauqua Rd, Allentown, PA 18109, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-d54d-74db-8271-1659536e3b66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-d54d-74db-8271-1659536e3b66",
        "storage_key": "property/6767906449166359/019fce12-d54d-74db-8271-1659536e3b66.webp",
        "width": 1280,
        "height": 672
      },
      "poi_business_url": "https://ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10544671045561141110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ollies-bargain-outlet",
      "poi_latitude": "40.639921",
      "poi_longitude": "-75.4292147",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-264-3885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-caa5-739b-a2db-e22406db9041",
        "storage_key": "property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8XHoXyw_xIkRdscEqHIyVpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7b0f20fc-6552-4e8f-8fed-2337257fde69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Marshalls & HomeGoods",
      "poi_type": "Shopping",
      "poi_address": "2144 W Union Blvd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-d747-76cc-8fe3-a699b0dd1d41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-d747-76cc-8fe3-a699b0dd1d41",
        "storage_key": "property/6767906449166359/019fce12-d747-76cc-8fe3-a699b0dd1d41.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3939365982688715718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls--homegoods",
      "poi_latitude": "40.628255",
      "poi_longitude": "-75.41994199999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-867-9413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-caa5-739b-a2db-e22406db9041",
        "storage_key": "property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKaWMdtk-xIkRxiNrVn1wqzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7629d9b8-97c1-4bb0-9cdc-e8eb3d3c8568",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Staples",
      "poi_type": "Shopping",
      "poi_address": "2138 W Union Blvd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_long_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-d9c4-708a-9915-caea308f361a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-d9c4-708a-9915-caea308f361a",
        "storage_key": "property/6767906449166359/019fce12-d9c4-708a-9915-caea308f361a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.staples.com/pa/bethlehem/2138-w-union-blvd?cmpid=st_ll_goo&cid=LS:RETAIL:G&utm_source=google&utm_medium=organic&utm_campaign=Google_Business_Listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=325053851296569402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "staples",
      "poi_latitude": "40.6284211",
      "poi_longitude": "-75.4190263",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-865-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-caa5-739b-a2db-e22406db9041",
        "storage_key": "property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ239m3ds-xIkROphna8HSggQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1122e5a1-ac46-4955-b258-c68fbce5beba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping",
      "poi_address": "2102 W Union Blvd #22A, Bethlehem, PA 18018, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-db10-734a-998c-86992ba4ae27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-db10-734a-998c-86992ba4ae27",
        "storage_key": "property/6767906449166359/019fce12-db10-734a-998c-86992ba4ae27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/pa/bethlehem-store2328.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=18358701227445525130&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "40.6293787",
      "poi_longitude": "-75.4178783",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 484-403-4296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-caa5-739b-a2db-e22406db9041",
        "storage_key": "property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA2ifrN4-xIkRihprb381x_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2ecb0691-74e2-4f0d-9b43-6682219e473a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "2124 W Union Blvd, Bethlehem, PA 18018, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-db6a-715f-861f-34dc60bbbfa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-db6a-715f-861f-34dc60bbbfa9",
        "storage_key": "property/6767906449166359/019fce12-db6a-715f-861f-34dc60bbbfa9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/pa/bethlehem/2124-west-union-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5213980964456535069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.6291906",
      "poi_longitude": "-75.4190263",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 484-935-3155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-caa5-739b-a2db-e22406db9041",
        "storage_key": "property/6767906449166359/019d026e-caa5-739b-a2db-e22406db9041.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL44n_ts-xIkRHZQU9A_IW0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bdfdc962-dcf1-4f9c-acd9-8f3c8244b863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Clearview Elementary School",
      "poi_type": "Education",
      "poi_address": "2121 Abington Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-de5f-724c-bf02-ef2cc95b6e60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-de5f-724c-bf02-ef2cc95b6e60",
        "storage_key": "property/6767906449166359/019fce12-de5f-724c-bf02-ef2cc95b6e60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://basdwpweb.beth.k12.pa.us/clearview/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6787824031190332796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearview-elementary-school",
      "poi_latitude": "40.6374885",
      "poi_longitude": "-75.4182793",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-868-5994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RwBISQ_xIkRfLX1MP4xM14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_472bcebe-6663-4846-b1ad-b819a6a2478d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Nitschmann Middle School",
      "poi_type": "Education",
      "poi_address": "1002 W Union Blvd, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e09a-75df-8d9a-6bae9dacf027.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e09a-75df-8d9a-6bae9dacf027",
        "storage_key": "property/6767906449166359/019fce12-e09a-75df-8d9a-6bae9dacf027.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://basdwpweb.beth.k12.pa.us/nitschmann/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17037504564646704011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nitschmann-middle-school",
      "poi_latitude": "40.6264167",
      "poi_longitude": "-75.3967488",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-866-5781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDVEZRPw-xIkRi_PcCiJgcew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_599f5982-ea77-4023-8896-189b4db7652a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Liberty High School",
      "poi_type": "Education",
      "poi_address": "1115 Linden St, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e1d1-75ba-bb36-e476d47043b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e1d1-75ba-bb36-e476d47043b5",
        "storage_key": "property/6767906449166359/019fce12-e1d1-75ba-bb36-e476d47043b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://basdwpweb.beth.k12.pa.us/liberty/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8228941729625803525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "liberty-high-school",
      "poi_latitude": "40.6291439",
      "poi_longitude": "-75.372455",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-691-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJK-MOpbM_xIkRBQu8f-cSM3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dd3e57a2-f099-4bc0-aae8-d455d84a8b98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "James Buchanan Elementary School",
      "poi_type": "Education",
      "poi_address": "1621 Catasauqua Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://basdwpweb.beth.k12.pa.us/jamesbuchanan/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3558247972057874038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-buchanan-elementary-school",
      "poi_latitude": "40.6378563",
      "poi_longitude": "-75.40688659999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-865-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl9DBDho_xIkRdn5Dna1vYTE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc16177b-e6f7-4779-8776-c5ddd7d4b3bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Notre Dame of Bethlehem School",
      "poi_type": "Education",
      "poi_address": "1835 Catasauqua Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e24e-714b-9dc7-18535f5c972e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e24e-714b-9dc7-18535f5c972e",
        "storage_key": "property/6767906449166359/019fce12-e24e-714b-9dc7-18535f5c972e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ndbethlehemschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12372188165025409141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "notre-dame-of-bethlehem-school",
      "poi_latitude": "40.6404018",
      "poi_longitude": "-75.4137537",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 610-866-2231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS5SQxCI_xIkRdaih3pXXsqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cedd872e-e2fb-463b-a315-6d22459475f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "A Child's Choice Montessori School",
      "poi_type": "Education",
      "poi_address": "402 3rd Ave, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e618-755e-ae23-26ea0a742300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e618-755e-ae23-26ea0a742300",
        "storage_key": "property/6767906449166359/019fce12-e618-755e-ae23-26ea0a742300.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.achildschoice.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10547064658886324726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-childs-choice-montessori-school",
      "poi_latitude": "40.619676",
      "poi_longitude": "-75.387807",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-533-5503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RMwME4-xIkR9vH-L22zXpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_716680ac-e9b8-474b-a2b0-affeb192979e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh Valley Charter High School for the Arts.",
      "poi_type": "Education",
      "poi_address": "321 E 3rd St, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e6b3-7498-adb7-256360cc8d8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e6b3-7498-adb7-256360cc8d8f",
        "storage_key": "property/6767906449166359/019fce12-e6b3-7498-adb7-256360cc8d8f.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.charterarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7290849444511516673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-charter-high-school-for-the-arts",
      "poi_latitude": "40.6123679",
      "poi_longitude": "-75.37365799999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-868-2971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLTRPVjQ-xIkRAYj28vBMLmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_41c7986f-558e-457b-bb10-86d2e31720f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Bethlehem Catholic High School",
      "poi_type": "Education",
      "poi_address": "2133 Madison Ave, Bethlehem, PA 18017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e81e-7495-92ac-f5ce960ce155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e81e-7495-92ac-f5ce960ce155",
        "storage_key": "property/6767906449166359/019fce12-e81e-7495-92ac-f5ce960ce155.webp",
        "width": 500,
        "height": 750
      },
      "poi_business_url": "http://becahi.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5158049352711603976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethlehem-catholic-high-school",
      "poi_latitude": "40.6424363",
      "poi_longitude": "-75.37172919999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-866-0791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVTTnDrw_xIkRCAdPyo4SlUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e4280c6f-5b7a-4a1d-b6ca-4668c1e39623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Moravian University",
      "poi_type": "Education",
      "poi_address": "1200 Main St, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e99f-72de-8936-61b6b50fe4fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e99f-72de-8936-61b6b50fe4fa",
        "storage_key": "property/6767906449166359/019fce12-e99f-72de-8936-61b6b50fe4fa.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.moravian.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=682176006117730931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moravian-university",
      "poi_latitude": "40.6310228",
      "poi_longitude": "-75.3809334",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-861-1320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfZpxvqs_xIkRcyrxlnaTdwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5962bb1f-cbcb-4628-b0dd-8179b7984c18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh University",
      "poi_type": "Education",
      "poi_address": "27 Memorial Dr W, Bethlehem, PA 18015, USA",
      "poi_short_description": "Research-geared private school known for its large, rural campus & business & engineering programs.",
      "poi_long_description": "Research-geared private school known for its large, rural campus & business & engineering programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-ecb6-71dc-902d-9f466447d65a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-ecb6-71dc-902d-9f466447d65a",
        "storage_key": "property/6767906449166359/019fce12-ecb6-71dc-902d-9f466447d65a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lehigh.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6751153047229936416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-university",
      "poi_latitude": "40.6054003",
      "poi_longitude": "-75.3771764",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-758-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5WpcfWc-xIkRILNvZO3psF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bc2cb076-b543-4ab0-a2c7-ec0552465db0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "ArtsQuest Center at SteelStacks",
      "poi_type": "Entertainment",
      "poi_address": "101 Founders Way, Bethlehem, PA 18015, USA",
      "poi_short_description": "Hip performing arts venue in the SteelStacks complex, hosting films, concerts & visual arts events.",
      "poi_long_description": "Hip performing arts venue in the SteelStacks complex, hosting films, concerts & visual arts events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-ee66-7548-8db6-b1d328933628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-ee66-7548-8db6-b1d328933628",
        "storage_key": "property/6767906449166359/019fce12-ee66-7548-8db6-b1d328933628.webp",
        "width": 1280,
        "height": 848
      },
      "poi_business_url": "http://www.artsquest.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10116428910641392208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "artsquest-center-at-steelstacks",
      "poi_latitude": "40.614004",
      "poi_longitude": "-75.367718",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-332-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPYZjMEY-xIkRUKpFvn7GZIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f7938bfb-05c8-4efe-a41e-ac4582227cbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Levitt Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "789 E 1st St, Bethlehem, PA 18015, USA",
      "poi_short_description": "Relaxed venue hosting live music, food vendors and drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-ef39-73fc-9caf-372ce122b519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-ef39-73fc-9caf-372ce122b519",
        "storage_key": "property/6767906449166359/019fce12-ef39-73fc-9caf-372ce122b519.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.levittsteelstacks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5694359615224269903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levitt-pavilion",
      "poi_latitude": "40.6147445",
      "poi_longitude": "-75.3680992",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 610-332-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzda4MEY-xIkRT8zFaOZtBk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dda721a4-5d7d-4b73-849e-7c41b1cca989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "711 E 1st St",
      "poi_type": "Entertainment",
      "poi_address": "711 E 1st St, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8321235752032256543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "711-e-1st-st",
      "poi_latitude": "40.61488749999999",
      "poi_longitude": "-75.3693584",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzZdEUY-xIkRH8IpJNT3enM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe56fda4-637d-452f-96cf-fe6e02aad444",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Wind Creek Event Center",
      "poi_type": "Entertainment",
      "poi_address": "77 Wind Creek Blvd, Bethlehem, PA 18015, USA",
      "poi_short_description": "Contemporary 14,000-square-foot venue for comedy, music, sports & other shows, plus private events.",
      "poi_long_description": "Contemporary 14,000-square-foot venue for comedy, music, sports & other shows, plus private events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-f042-7757-933e-bd7ad40b461c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-f042-7757-933e-bd7ad40b461c",
        "storage_key": "property/6767906449166359/019fce12-f042-7757-933e-bd7ad40b461c.webp",
        "width": 1280,
        "height": 805
      },
      "poi_business_url": "http://www.windcreekeventcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6681909497028383660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wind-creek-event-center",
      "poi_latitude": "40.6153202",
      "poi_longitude": "-75.3591574",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-297-7414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo66TRTc-xIkRrJOvB0npulw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a1c177b-ac82-40e4-98ad-eb18f2ca3c57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Zoellner Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "420 E Packer Ave, Bethlehem, PA 18015, USA",
      "poi_short_description": "Modern building at Lehigh University featuring 3 theaters, a 2-story art gallery & classrooms.",
      "poi_long_description": "Modern building at Lehigh University featuring 3 theaters, a 2-story art gallery & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-f3bb-7628-bb86-49c8e8afad16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-f3bb-7628-bb86-49c8e8afad16",
        "storage_key": "property/6767906449166359/019fce12-f3bb-7628-bb86-49c8e8afad16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://zoellner.cas2.lehigh.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9625050845818643008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zoellner-arts-center",
      "poi_latitude": "40.6081278",
      "poi_longitude": "-75.37255329999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-758-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2ufU0I-xIkRQOIXor8Mk4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07a38d30-f795-4f83-8c57-2fc6ba33db38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "ArtsQuest",
      "poi_type": "Entertainment",
      "poi_address": "101 Founders Way, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-f4bc-74c4-b2e2-fb98608a9557.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-f4bc-74c4-b2e2-fb98608a9557",
        "storage_key": "property/6767906449166359/019fce12-f4bc-74c4-b2e2-fb98608a9557.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.artsquest.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15478805136850989197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "artsquest",
      "poi_latitude": "40.6140456",
      "poi_longitude": "-75.3675986",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-332-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6nwdlw-xIkRjbB-AUPDz9Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8dd61cb1-ad57-48e8-bf5a-69cf94730b44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Kemerer Museum of Decorative Arts",
      "poi_type": "Entertainment",
      "poi_address": "427 N New St, Bethlehem, PA 18018, USA",
      "poi_short_description": "Housed in 3 connected 19th-century homes, this museum features exhibits on decorative arts.",
      "poi_long_description": "Housed in 3 connected 19th-century homes, this museum features exhibits on decorative arts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-f5bf-76c3-a14b-90b196a84a07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-f5bf-76c3-a14b-90b196a84a07",
        "storage_key": "property/6767906449166359/019fce12-f5bf-76c3-a14b-90b196a84a07.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://historicbethlehem.org/?historic-site=kemerer-museum-of-decorative-arts",
      "poi_directions_map_url": "https://maps.google.com/?cid=3373939907820678709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemerer-museum-of-decorative-arts",
      "poi_latitude": "40.6196186",
      "poi_longitude": "-75.3788003",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 610-868-6868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-261b12112f8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-261b12112f8c",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-261b12112f8c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_DeUlA-xIkRNW4qY3ik0i4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba6aa416-28bd-48a5-81f5-69af15fa7ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Da Vinci Science Center",
      "poi_type": "Entertainment",
      "poi_address": "815 Hamilton St, Allentown, PA 18101, USA",
      "poi_short_description": "Innovative exhibits & hands-on science experiments for all ages in a modern, two-story space.",
      "poi_long_description": "Innovative exhibits & hands-on science experiments for all ages in a modern, two-story space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-f6e7-76e8-9944-fcc72bd261a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-f6e7-76e8-9944-fcc72bd261a6",
        "storage_key": "property/6767906449166359/019fce12-f6e7-76e8-9944-fcc72bd261a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.davincisciencecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7220110388974632674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "da-vinci-science-center",
      "poi_latitude": "40.6018875",
      "poi_longitude": "-75.4745789",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 484-664-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-261b12112f8c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-261b12112f8c",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-261b12112f8c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbasK3gw6xIkR4r7wHSX8MmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0e7d8058-fc1e-482d-aa91-e0ab3863c570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lost River Caverns",
      "poi_type": "Entertainment",
      "poi_address": "726 Durham St, Hellertown, PA 18055, USA",
      "poi_short_description": "Attraction since 1930 with underground walking tours, museum, trail, gem mill, store & picnic areas.",
      "poi_long_description": "Attraction since 1930 with underground walking tours, museum, trail, gem mill, store & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-f9dc-754f-9550-0a5aab85c400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-f9dc-754f-9550-0a5aab85c400",
        "storage_key": "property/6767906449166359/019fce12-f9dc-754f-9550-0a5aab85c400.webp",
        "width": 798,
        "height": 1200
      },
      "poi_business_url": "http://lostcave.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17121194262952685272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lost-river-caverns",
      "poi_latitude": "40.5808368",
      "poi_longitude": "-75.3306133",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 610-838-8767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6oIhAcWxIkR2C7AXXizmu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3709d678-2253-4a74-8574-8367b7a35284",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Fegley's Bethlehem Brew Works",
      "poi_type": "Entertainment",
      "poi_address": "559 Main St #101, Bethlehem, PA 18018, USA",
      "poi_short_description": "Restaurant & brewery offering beers & hearty pub grub in an airy, industrial space.",
      "poi_long_description": "Restaurant & brewery offering beers & hearty pub grub in an airy, industrial space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-bd8d-71bf-80ed-955f3c512568.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-bd8d-71bf-80ed-955f3c512568",
        "storage_key": "property/6767906449166359/019fce12-bd8d-71bf-80ed-955f3c512568.webp",
        "width": 1267,
        "height": 1280
      },
      "poi_business_url": "https://www.thebrewworks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2121624635793940899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fegleys-bethlehem-brew-works",
      "poi_latitude": "40.622284",
      "poi_longitude": "-75.3821372",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-882-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c365-745c-880d-40e057b64f6b",
        "storage_key": "property/6767906449166359/019d026e-c365-745c-880d-40e057b64f6b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySvFqlY-xIkRoyE3i12GcR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2d0c423d-4d50-4045-ac1e-417860ae8213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh Valley Hospital–Muhlenberg",
      "poi_type": "Health and Wellness",
      "poi_address": "2545 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-fbeb-72fa-afc0-24432e249741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-fbeb-72fa-afc0-24432e249741",
        "storage_key": "property/6767906449166359/019fce12-fbeb-72fa-afc0-24432e249741.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.lvhn.org/locations/lehigh-valley-hospital-muhlenberg",
      "poi_directions_map_url": "https://maps.google.com/?cid=1785214734762180312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-hospitalmuhlenberg",
      "poi_latitude": "40.6448317",
      "poi_longitude": "-75.4081334",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-402-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfc7-76d9-a93a-456f4f827963",
        "storage_key": "property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYsxXRY_xIkR2P5KwVdbxhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c665e247-ceaa-459c-b187-9fc0284fbad7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "MinuteClinic at CVS",
      "poi_type": "Health",
      "poi_address": "2434 Catasauqua Rd, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-fb5e-75cb-b489-57e91aea1e0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-fb5e-75cb-b489-57e91aea1e0d",
        "storage_key": "property/6767906449166359/019fce12-fb5e-75cb-b489-57e91aea1e0d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.cvs.com/minuteclinic/clinic-locator/pa/bethlehem/1036.html?WT.mc_id=LS_mc_google_carenav_1036",
      "poi_directions_map_url": "https://maps.google.com/?cid=10954797496476814490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "minuteclinic-at-cvs",
      "poi_latitude": "40.643516",
      "poi_longitude": "-75.42728029999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 866-389-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0OU2zE_xIkRmszWM0hCB5g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6b4199b-37a7-42da-a06d-091e4eaeeccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health",
      "poi_address": "2240 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-fd71-70dc-80b5-9c0ace1b7fc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-fd71-70dc-80b5-9c0ace1b7fc5",
        "storage_key": "property/6767906449166359/019fce12-fd71-70dc-80b5-9c0ace1b7fc5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2240+schoenersville+rd-bethlehem-pa-18017/id=4852",
      "poi_directions_map_url": "https://maps.google.com/?cid=352699470378869419&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.6410718",
      "poi_longitude": "-75.39956169999999",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-861-7494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfti3w8_xIkRq6JmtEwK5QQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7576e528-78a6-4b24-b21a-8ce371fdc145",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Bethlehem YMCA",
      "poi_type": "Health",
      "poi_address": "430 E Broad St, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-00b8-7316-875c-4600f87639a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-00b8-7316-875c-4600f87639a3",
        "storage_key": "property/6767906449166359/019fce13-00b8-7316-875c-4600f87639a3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcarivercrossing.org/locations/bethlehem?utm_source=google&utm_medium=local&utm_campaign=gbp_bethlehem",
      "poi_directions_map_url": "https://maps.google.com/?cid=9266431093485488356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethlehem-ymca",
      "poi_latitude": "40.6216276",
      "poi_longitude": "-75.3678553",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-867-7588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc3pNzEs-xIkR5EjW3vv5mIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db1167fc-863e-4a3c-933f-decb27da5a06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "LVHN Child Care Center operated by River Crossing YMCA",
      "poi_type": "Health",
      "poi_address": "2435 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-0172-728c-bbb3-c660336e692a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-0172-728c-bbb3-c660336e692a",
        "storage_key": "property/6767906449166359/019fce13-0172-728c-bbb3-c660336e692a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcarivercrossing.org/child-care/lvhn-child-care-center?utm_source=google&utm_medium=local&utm_campaign=gbp_cclvh",
      "poi_directions_map_url": "https://maps.google.com/?cid=6391141681515617949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lvhn-child-care-center-operated-by-river-crossing-ymca",
      "poi_latitude": "40.6428433",
      "poi_longitude": "-75.40570780000002",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 610-596-8644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ22AdOKk_xIkRnV7uY3_lsVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7cabe702-ede1-4a8d-a38e-d9004a58b97a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Inner Strength Fitness & Yoga Studio",
      "poi_type": "Health",
      "poi_address": "2485 Willow Park Rd, Bethlehem, PA 18020, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-0246-737f-9685-6ff6db9f38c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-0246-737f-9685-6ff6db9f38c5",
        "storage_key": "property/6767906449166359/019fce13-0246-737f-9685-6ff6db9f38c5.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.innerstrengthfitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12998026556937022111&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inner-strength-fitness--yoga-studio",
      "poi_latitude": "40.6512106",
      "poi_longitude": "-75.3332858",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 610-419-6133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65kVpVsVxIkRnypTe0lEYrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7b3a8f19-3b2b-4862-b45d-77f1578f259e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Yogalab",
      "poi_type": "Health",
      "poi_address": "623 E Broad St, Bethlehem, PA 18018, USA",
      "poi_short_description": "Yoga, hot yoga and aerial yoga classes at a clean studio featuring supportive instructors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-03ea-738f-b2f7-c4ec9e49ec35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-03ea-738f-b2f7-c4ec9e49ec35",
        "storage_key": "property/6767906449166359/019fce13-03ea-738f-b2f7-c4ec9e49ec35.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "https://agyogalab.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12264085829167912230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogalab",
      "poi_latitude": "40.6223261",
      "poi_longitude": "-75.3631338",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 484-641-8062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPx7cw8c7xIkRJpV0bhXJMqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_104e7bd6-d53c-499a-9f15-591d288f4837",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Kula Heart Yoga and Wellness, LLC",
      "poi_type": "Health",
      "poi_address": "107 N Chestnut St Suite 8, Bath, PA 18014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-07ab-75bb-a924-b5252ae7dfac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-07ab-75bb-a924-b5252ae7dfac",
        "storage_key": "property/6767906449166359/019fce13-07ab-75bb-a924-b5252ae7dfac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kulaheartyogaandwellness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2291963607210172341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kula-heart-yoga-and-wellness-llc",
      "poi_latitude": "40.7271917",
      "poi_longitude": "-75.3936737",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 610-746-5852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkwWPpYY_xIkRtZ_i5cGwzh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3fc23326-f5cd-460f-a5ef-38468d971c8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "St. Luke's University Hospital - Bethlehem Campus",
      "poi_type": "Health",
      "poi_address": "801 Ostrum St, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-083a-7440-8a3e-9e6b4dd3c504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-083a-7440-8a3e-9e6b4dd3c504",
        "storage_key": "property/6767906449166359/019fce13-083a-7440-8a3e-9e6b4dd3c504.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.slhn.org/locations/stlukes-university-hospital-bethlehem-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=13275186697069017736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-university-hospital---bethlehem-campus",
      "poi_latitude": "40.6091715",
      "poi_longitude": "-75.393079",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 866-785-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfc7-76d9-a93a-456f4f827963",
        "storage_key": "property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z-DVIs-xIkRiDrKTffvOrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97ffbf43-387d-479d-8470-d7eae3d8d62e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Monocacy Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "100 Illick's Mill Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "Creekside park featuring fishing, trails, a nature center, picnic areas & 2 pavilions.",
      "poi_long_description": "Creekside park featuring fishing, trails, a nature center, picnic areas & 2 pavilions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-09e3-7043-b1f7-da60e468b468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-09e3-7043-b1f7-da60e468b468",
        "storage_key": "property/6767906449166359/019fce13-09e3-7043-b1f7-da60e468b468.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bethlehem-pa.gov/Recreation/Rental-Facilities/Park-Pavilions",
      "poi_directions_map_url": "https://maps.google.com/?cid=17082897614015871347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monocacy-park",
      "poi_latitude": "40.64151400000001",
      "poi_longitude": "-75.38004339999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-865-7081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeeSvCwg_xIkRc7nI8d6kEu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_75907394-dc0f-4f0d-90a1-a477cdb07c4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Saucon Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "1204 William St, Bethlehem, PA 18015, USA",
      "poi_short_description": "A stream runs through this picturesque, treed park with a running trail & a children's playground.",
      "poi_long_description": "A stream runs through this picturesque, treed park with a running trail & a children's playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-0b0a-719c-a180-4a80a8817be3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-0b0a-719c-a180-4a80a8817be3",
        "storage_key": "property/6767906449166359/019fce13-0b0a-719c-a180-4a80a8817be3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7748369622267853254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saucon-park",
      "poi_latitude": "40.5975065",
      "poi_longitude": "-75.3507826",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 610-865-7081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1ljvx4-xIkRxvmzax69h2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5d3fecc5-6fb7-4434-a5bd-e68824da6792",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Sand Island Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "56 River St, Bethlehem, PA 18018, USA",
      "poi_short_description": "Urban park with clay tennis courts, a clubhouse & lessons, plus a playground & biking/hiking trails.",
      "poi_long_description": "Urban park with clay tennis courts, a clubhouse & lessons, plus a playground & biking/hiking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-0f04-736d-b03b-6e0ba19de2bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-0f04-736d-b03b-6e0ba19de2bb",
        "storage_key": "property/6767906449166359/019fce13-0f04-736d-b03b-6e0ba19de2bb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1171864608493780436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sand-island-park",
      "poi_latitude": "40.61611449999999",
      "poi_longitude": "-75.3809612",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-865-7081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJORllllo-xIkR1L0fEqdMQxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d8fb13e3-965a-45cf-bc9e-049e273657bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "324 S New St",
      "poi_type": "Outdoor Attractions",
      "poi_address": "324 S New St, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14725122393826524181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "324-s-new-st",
      "poi_latitude": "40.6110218",
      "poi_longitude": "-75.3788363",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxRpiVw-xIkRFfwt1swkWsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0a9a7b92-2a48-4777-b264-e4082efa5ce6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "South Mountain Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "1515 Mountain Dr N, Bethlehem, PA 18015, USA",
      "poi_short_description": "Disc-golf, mountain-biking and hiking spot for all ages, featuring wooded trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-0f03-77cb-9c8a-7437e3e691a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-0f03-77cb-9c8a-7437e3e691a2",
        "storage_key": "property/6767906449166359/019fce13-0f03-77cb-9c8a-7437e3e691a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10822399312089121422&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-mountain-park",
      "poi_latitude": "40.595014",
      "poi_longitude": "-75.38012599999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdHcv3s-xIkRjgKBttXiMJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9d536f7a-009f-44e4-9476-1d93f9be4909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Saucon Rail Trail",
      "poi_type": "Outdoor Attractions",
      "poi_address": "Bethlehem, PA 18015, USA",
      "poi_short_description": "Park with crushed-stone trails for walking, running, and biking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-11f0-77ee-a753-58a8ff37d37e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-11f0-77ee-a753-58a8ff37d37e",
        "storage_key": "property/6767906449166359/019fce13-11f0-77ee-a753-58a8ff37d37e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sauconrailtrail.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13557913010089508870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saucon-rail-trail",
      "poi_latitude": "40.5405189",
      "poi_longitude": "-75.3850183",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB56amuI8xIkRBkAIvgxiJ7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_90794b78-9a6c-4fdc-8e89-d4a3262b87bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lechauweki Springs",
      "poi_type": "Outdoor Attractions",
      "poi_address": "805 Lechauweki Ave, Fountain Hill, PA 18015, USA",
      "poi_short_description": "Park with a gazebo, trails, and a pond, plus historical features.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1344-723f-a3ac-948f0b7a0149.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1344-723f-a3ac-948f0b7a0149",
        "storage_key": "property/6767906449166359/019fce13-1344-723f-a3ac-948f0b7a0149.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7070457459269128330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lechauweki-springs",
      "poi_latitude": "40.5958806",
      "poi_longitude": "-75.4018765",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVedycZs-xIkRilA_K5lPH2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4d4714d2-2cb5-4524-845d-925d3160bf6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Janet Johnston Housenick and William D. Housenick Memorial Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "3811 Christian Spring Rd, Bethlehem, PA 18020, USA",
      "poi_short_description": "Estate featuring a mansion, grounds with wildflowers, and walking paths, plus tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-16a7-76fb-af23-29df51328840.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-16a7-76fb-af23-29df51328840",
        "storage_key": "property/6767906449166359/019fce13-16a7-76fb-af23-29df51328840.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bethlehemtownship.org/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=10390153636505275780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "janet-johnston-housenick-and-william-d-housenick-memorial-park",
      "poi_latitude": "40.6723646",
      "poi_longitude": "-75.3518583",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-814-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfe6-77a1-9d43-2a162e227c96",
        "storage_key": "property/6767906449166359/019d026e-cfe6-77a1-9d43-2a162e227c96.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3XLORtAxIkRhE2h2a49MZA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e580d60-6190-44ac-a6e9-dd83fa14f373",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Bethlehem Transportation Center",
      "poi_type": "Transit",
      "poi_address": "635 Guetter St, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-16ba-75fc-ad2e-2d812a3a120b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-16ba-75fc-ad2e-2d812a3a120b",
        "storage_key": "property/6767906449166359/019fce13-16ba-75fc-ad2e-2d812a3a120b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lantabus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6933764805591296958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethlehem-transportation-center",
      "poi_latitude": "40.6231285",
      "poi_longitude": "-75.3806652",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-867-3988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgw8oXlk_xIkRvutfoVquOWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5f608271-0030-4dcd-8d77-fc0bb41bd062",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Trans-Bridge-Lines",
      "poi_type": "Transit",
      "poi_address": "2012 Industrial Dr, Bethlehem, PA 18017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1913-7255-b0b6-ac5faa0e8ad8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1913-7255-b0b6-ac5faa0e8ad8",
        "storage_key": "property/6767906449166359/019fce13-1913-7255-b0b6-ac5faa0e8ad8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.transbridgelines.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11067938445681143347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trans-bridge-lines",
      "poi_latitude": "40.6514184",
      "poi_longitude": "-75.4173507",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-868-6001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWzYqzg_xIkRM662OmA3mZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb37348e-bfa2-46b3-9a5a-4a3dab9add1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh Valley International Airport",
      "poi_type": "Transit",
      "poi_address": "3311 Airport Rd, Allentown, PA 18109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1a65-7117-9d6f-582e7770d725.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1a65-7117-9d6f-582e7770d725",
        "storage_key": "property/6767906449166359/019fce13-1a65-7117-9d6f-582e7770d725.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flyabe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=807841022593771884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-international-airport",
      "poi_latitude": "40.6510611",
      "poi_longitude": "-75.44388529999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-359-5842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfdd-71f9-929d-caf2e55b1add.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfdd-71f9-929d-caf2e55b1add",
        "storage_key": "property/6767906449166359/019d026e-cfdd-71f9-929d-caf2e55b1add.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ866awjQ_xIkRbKmwQiEHNgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_55302ffa-1724-4843-9b3a-83143db31629",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Allentown Transportation Center",
      "poi_type": "Transit",
      "poi_address": "152-132 N Church St, Allentown, PA 18102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1d67-76b8-9b44-d2c1c1598685.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1d67-76b8-9b44-d2c1c1598685",
        "storage_key": "property/6767906449166359/019fce13-1d67-76b8-9b44-d2c1c1598685.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://lantabus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11180640157199306191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allentown-transportation-center",
      "poi_latitude": "40.6047425",
      "poi_longitude": "-75.4712804",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 610-841-9090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_RAokBE5xIkRzw1VQ_ycKZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6dc4d244-b79b-4f03-bb8b-1cbce9728220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "EITC - Easton Intermodal Transit Center",
      "poi_type": "Transit",
      "poi_address": "Easton, PA 18042, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1d8c-73cd-a37c-dac8a1560c4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1d8c-73cd-a37c-dac8a1560c4e",
        "storage_key": "property/6767906449166359/019fce13-1d8c-73cd-a37c-dac8a1560c4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10771326887449146082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eitc---easton-intermodal-transit-center",
      "poi_latitude": "40.688964",
      "poi_longitude": "-75.209638",
      "poi_miles_from_property": "12.9 mi",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYy4s11ZsxIkR4jIFNrxwe5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7014f304-85c4-4b87-ad92-954f4908e09a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "William Penn Highway Park and Ride",
      "poi_type": "Transit",
      "poi_address": "5715 William Penn Hwy, Easton, PA 18045, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1e9c-748a-a93d-81437b91020f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1e9c-748a-a93d-81437b91020f",
        "storage_key": "property/6767906449166359/019fce13-1e9c-748a-a93d-81437b91020f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9773681085987407208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-penn-highway-park-and-ride",
      "poi_latitude": "40.6685897",
      "poi_longitude": "-75.2949335",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-d43c-743b-83bd-d81a95a26899.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-d43c-743b-83bd-d81a95a26899",
        "storage_key": "property/6767906449166359/019d026e-d43c-743b-83bd-d81a95a26899.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJN13tg49rxIkRaMU7HioXo4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_75e7c4e8-860e-48ad-b468-07ec4fff0e26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "PennDOT Hellertown Park & Ride",
      "poi_type": "Transit",
      "poi_address": "Silvex Rd, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3890603006713929571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penndot-hellertown-park--ride",
      "poi_latitude": "40.5974718",
      "poi_longitude": "-75.34234649999999",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-200-8231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-d43c-743b-83bd-d81a95a26899.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-d43c-743b-83bd-d81a95a26899",
        "storage_key": "property/6767906449166359/019d026e-d43c-743b-83bd-d81a95a26899.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-90JWI_xIkRYx9AQdIy_jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dbeef5a5-666e-456e-97f8-c5d897f2442a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Park and Ride - Wescosville",
      "poi_type": "Transit",
      "poi_address": "548518410940, Allentown, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-20d5-7351-b440-e478eabc660f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-20d5-7351-b440-e478eabc660f",
        "storage_key": "property/6767906449166359/019fce13-20d5-7351-b440-e478eabc660f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.penndot.gov/TravelInPA/Ridesharing/Pages/Park-and-Ride-Map.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16372810812035177285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-and-ride---wescosville",
      "poi_latitude": "40.5699371",
      "poi_longitude": "-75.54334519999999",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-d43c-743b-83bd-d81a95a26899.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-d43c-743b-83bd-d81a95a26899",
        "storage_key": "property/6767906449166359/019d026e-d43c-743b-83bd-d81a95a26899.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJpbLvq8gxxIkRRRsIyq_oN-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d1af60a4-0c40-478d-8b71-8ec0eb55642a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "St. Luke's University Hospital - Bethlehem Campus",
      "poi_type": "Major Employers",
      "poi_address": "801 Ostrum St, Bethlehem, PA 18015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-083a-7440-8a3e-9e6b4dd3c504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-083a-7440-8a3e-9e6b4dd3c504",
        "storage_key": "property/6767906449166359/019fce13-083a-7440-8a3e-9e6b4dd3c504.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.slhn.org/locations/stlukes-university-hospital-bethlehem-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=13275186697069017736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-lukes-university-hospital---bethlehem-campus",
      "poi_latitude": "40.6091715",
      "poi_longitude": "-75.393079",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 866-785-8537",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfc7-76d9-a93a-456f4f827963",
        "storage_key": "property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1z-DVIs-xIkRiDrKTffvOrg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_edaa8f4b-70a0-4251-ada2-f5cfb9706221",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh University",
      "poi_type": "Major Employers",
      "poi_address": "27 Memorial Dr W, Bethlehem, PA 18015, USA",
      "poi_short_description": "Research-geared private school known for its large, rural campus & business & engineering programs.",
      "poi_long_description": "Research-geared private school known for its large, rural campus & business & engineering programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-ecb6-71dc-902d-9f466447d65a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-ecb6-71dc-902d-9f466447d65a",
        "storage_key": "property/6767906449166359/019fce12-ecb6-71dc-902d-9f466447d65a.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lehigh.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6751153047229936416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-university",
      "poi_latitude": "40.6054003",
      "poi_longitude": "-75.3771764",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 610-758-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5WpcfWc-xIkRILNvZO3psF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba2f7cbc-5b69-4bd6-83d9-13f582cc97e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Moravian University",
      "poi_type": "Major Employers",
      "poi_address": "1200 Main St, Bethlehem, PA 18018, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-e99f-72de-8936-61b6b50fe4fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-e99f-72de-8936-61b6b50fe4fa",
        "storage_key": "property/6767906449166359/019fce12-e99f-72de-8936-61b6b50fe4fa.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.moravian.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=682176006117730931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moravian-university",
      "poi_latitude": "40.6310228",
      "poi_longitude": "-75.3809334",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 610-861-1320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cb09-7642-b2b8-61f0c6212a59",
        "storage_key": "property/6767906449166359/019d026e-cb09-7642-b2b8-61f0c6212a59.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfZpxvqs_xIkRcyrxlnaTdwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2e63f0e7-305a-4033-b6c8-268897ec6e51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh Valley Hospital–Muhlenberg",
      "poi_type": "Major Employers",
      "poi_address": "2545 Schoenersville Rd, Bethlehem, PA 18017, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce12-fbeb-72fa-afc0-24432e249741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce12-fbeb-72fa-afc0-24432e249741",
        "storage_key": "property/6767906449166359/019fce12-fbeb-72fa-afc0-24432e249741.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.lvhn.org/locations/lehigh-valley-hospital-muhlenberg",
      "poi_directions_map_url": "https://maps.google.com/?cid=1785214734762180312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-hospitalmuhlenberg",
      "poi_latitude": "40.6448317",
      "poi_longitude": "-75.4081334",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 610-402-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfc7-76d9-a93a-456f4f827963",
        "storage_key": "property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYsxXRY_xIkR2P5KwVdbxhg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9aa0b94a-063e-448a-959d-38f3f16a0181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh Valley Hospital–Cedar Crest",
      "poi_type": "Major Employers",
      "poi_address": "1200 S Cedar Crest Blvd, Allentown, PA 18103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-247b-75f2-ac38-738124091825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-247b-75f2-ac38-738124091825",
        "storage_key": "property/6767906449166359/019fce13-247b-75f2-ac38-738124091825.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.lvhn.org/locations/lehigh-valley-hospital-cedar-crest",
      "poi_directions_map_url": "https://maps.google.com/?cid=11224698833635954574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-hospitalcedar-crest",
      "poi_latitude": "40.5664156",
      "poi_longitude": "-75.5238103",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 610-402-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfc7-76d9-a93a-456f4f827963",
        "storage_key": "property/6767906449166359/019d026e-cfc7-76d9-a93a-456f4f827963.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ14vd8Yc6xIkRjs-cQR4kxps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_75135b3d-8b77-4dcc-9d1e-f9e82cda6a9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Air Products and Chemicals, Inc.",
      "poi_type": "Major Employers",
      "poi_address": "1940 Air Products Blvd, Allentown, PA 18106, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-2453-75a9-879d-012772ad5982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-2453-75a9-879d-012772ad5982",
        "storage_key": "property/6767906449166359/019fce13-2453-75a9-879d-012772ad5982.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.airproducts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1528790162020138751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "air-products-and-chemicals-inc",
      "poi_latitude": "40.5601798",
      "poi_longitude": "-75.5816215",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 40 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 610-481-4911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8-GoQoixIkR_35Sb41aNxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_18204c47-7673-4194-bfb7-106cdad98d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "PPL Corporation",
      "poi_type": "Major Employers",
      "poi_address": "645 Hamilton St Suite 601, Allentown, PA 18101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-2595-76cd-84e3-e211d40828f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-2595-76cd-84e3-e211d40828f9",
        "storage_key": "property/6767906449166359/019fce13-2595-76cd-84e3-e211d40828f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pplweb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3909012689617477075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ppl-corporation",
      "poi_latitude": "40.6027013",
      "poi_longitude": "-75.4713338",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 610-774-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCa5Oen45xIkR090kk1SaPzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54bd6667-6728-4826-b7ed-6fca927db0d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Wind Creek Bethlehem",
      "poi_type": "Major Employers",
      "poi_address": "77 Wind Creek Blvd, Bethlehem, PA 18015, USA",
      "poi_short_description": "Lively property with a casino, an event center & an outlet mall, plus a pool, dining & free Wi-Fi.",
      "poi_long_description": "Lively property with a casino, an event center & an outlet mall, plus a pool, dining & free Wi-Fi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-26cf-7188-bb86-b7e34d56c7f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-26cf-7188-bb86-b7e34d56c7f2",
        "storage_key": "property/6767906449166359/019fce13-26cf-7188-bb86-b7e34d56c7f2.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://windcreek.com/bethlehem",
      "poi_directions_map_url": "https://maps.google.com/?cid=9121437475915592798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wind-creek-bethlehem",
      "poi_latitude": "40.6140872",
      "poi_longitude": "-75.3569271",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 484-777-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-d43a-7794-8d51-2e70dd90720e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-d43a-7794-8d51-2e70dd90720e",
        "storage_key": "property/6767906449166359/019d026e-d43a-7794-8d51-2e70dd90720e.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJqy8fbzo-xIkRXnTikA7blX4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_60c5382f-4109-4c96-a20c-d1e2cc50f081",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "Lehigh Valley International Airport",
      "poi_type": "Major Employers",
      "poi_address": "3311 Airport Rd, Allentown, PA 18109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-1a65-7117-9d6f-582e7770d725.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-1a65-7117-9d6f-582e7770d725",
        "storage_key": "property/6767906449166359/019fce13-1a65-7117-9d6f-582e7770d725.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.flyabe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=807841022593771884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lehigh-valley-international-airport",
      "poi_latitude": "40.6510611",
      "poi_longitude": "-75.44388529999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-359-5842",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-cfdd-71f9-929d-caf2e55b1add.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-cfdd-71f9-929d-caf2e55b1add",
        "storage_key": "property/6767906449166359/019d026e-cfdd-71f9-929d-caf2e55b1add.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ866awjQ_xIkRbKmwQiEHNgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_808672a5-5986-40d4-9836-6eba926c7409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "poi_name": "C. F. Martin & Co., Inc.",
      "poi_type": "Major Employers",
      "poi_address": "510 Sycamore St, Nazareth, PA 18064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019fce13-2b4f-7465-aad7-faf072720a64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fce13-2b4f-7465-aad7-faf072720a64",
        "storage_key": "property/6767906449166359/019fce13-2b4f-7465-aad7-faf072720a64.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.martinguitar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8328452246034003149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "c-f-martin--co-inc",
      "poi_latitude": "40.7548538",
      "poi_longitude": "-75.30598359999999",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 610-759-2837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d026e-c363-76b9-973f-07aa583698c6",
        "storage_key": "property/6767906449166359/019d026e-c363-76b9-973f-07aa583698c6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwfvkN5hpxIkRzTSpFTGblHM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f575a025-aeeb-4ad8-b0a3-aed8374b5e4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_e332d7b1-8b9f-47c7-81cb-faf1f1c0eaa4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_e493acdf-e9fe-48d1-ac42-211dd1b1ba47",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_3c61a436-3ec6-4105-b254-a20338f6328f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_0ff00503-5423-4801-8cb1-e82f9e62495b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_339594cd-b72e-4953-bc77-37534bab03f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_28a9d7f5-e229-41ad-b573-fe5e420faeeb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "day": "SUN",
      "open_time": "12:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_011d2d77-a56b-4166-85b0-a7230339da5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "rating": "5.0",
      "name": "Karen García García (Sharlyn)",
      "text": "We are here on a six month lease and I have to say that both Zach and Erica have been very kind and accommodating. This transition was not easy, but they both were very patient and understanding. I would totally recommend this apartment complex to anyone in the Lehigh Valley area because they take Customer Service to another level.",
      "date": "2025-04-01",
      "title": ""
    },
    {
      "id": "custom_4c8a91ef-c266-4d30-9039-8ecc3f8f549b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "rating": "5.0",
      "name": "Tony Kadmiel",
      "text": "Five Stars for Valley Park Apartments in Bethlehem, PA!\n\nI was absolutely flabbergasted by my first phone call to Valley Park Apartments. From India, I spoke with Erika for 18 minutes. She was incredibly kind, patient, and provided detailed assistance on the application process and document uploading. Her phenomenal support, especially for international residents like me, made a world of difference.\n\nDuring the application process, I had multiple interactions with Zach. He’s a fantastic person and very helpful in processing my application. Zach assisted me with uploading the necessary documents and answered every single question I had. I spoke with him more than 10 times, and each time, he helped without any hesitation, going above and beyond.\n\nAs an international resident, I’ve had bad experiences with other landlords, but Valley Park Apartments stands out for their patience and understanding. Even though my English is not perfect, they listened and assisted me with great care.\n\nLastly, I spoke with Terry, the property manager. She epitomizes patience and understanding. She quickly responded to my application in a positive manner.\n\nThe day I arrived and received the keys from Terry and Zach, they welcomed me with exquisite chocolate chip cookies. I hope this review reaches the senior management.\n\nThank you,\n\nKadmiel",
      "date": "2024-06-18",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_fb8a9c50-8562-459f-994e-4e431aff7052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/019eb009-1c42-72cc-90c5-c1a40bd291c9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of a modern apartment kitchen and living area with hardwood floors and stainless steel appliances.",
        "public_id": "019eb009-1c42-72cc-90c5-c1a40bd291c9",
        "storage_key": "property/6767906449166359/019eb009-1c42-72cc-90c5-c1a40bd291c9.webp",
        "width": 2000,
        "height": 1000
      },
      "virtual_tour_title": "2 Bed l 1 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=65ca843754ad9760cbf40838&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_4e1d9ac0960e47faaba5903e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429706",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_34f8be0de5b1ff7c02c192db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429707",
      "name": "Admin Fee",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f7d76e18cf0aab56f49a030f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429708",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_8e170d02dab88f0206a6c614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429709",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1061904b8d4165622681c689",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429710",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_06d5abbe4b4563de1f1be384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429711",
      "name": "Pet Fee",
      "description": "One-time fee of $350 covers up to 2 pets.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a70ad264cce22460ca2d6477",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429713",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_874d9df2ebbc77287cd17c47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429717",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_56933aef0ce00716b32ea2b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "429718",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c22b64f7e478dcb289936051",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "572109",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_327b95207001b2e99e83666f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "572112",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fde77f68425a420fb976ffb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "572113",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8d9b7f2a4ea4e7b654e55c57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "572114",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_824e578f8df3820ee1d43205",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "572115",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_223f65dae3cdbb775e82120f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "572116",
      "name": "Trash Service",
      "description": "false",
      "amount": 15,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2c034a273cd1a6e6d1960763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "835298",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fde88ece222e93fab99f990f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "835302",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_916a8ec17937c6f73d6ea8ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "835305",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_98268dd419a0682d3c775077",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "835314",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_23c4162207fa066254281446",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "engrain",
      "external_id": "835321",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1716-2150-73fa-9c96-83ff77ddd9e2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-valley-park-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359"
    },
    {
      "lead_collector_id": "019c3043-bc4f-743f-9507-1a9a518de218",
      "lead_source": "FACEBOOK_ADS",
      "name": "valley-park",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359"
    },
    {
      "lead_collector_id": "019c3043-bcc2-7266-904e-b4afdfcc8151",
      "lead_source": "LANDING_PAGE",
      "name": "valley-park",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-bethlehem-pa-813",
      "search_query": "pet friendly apartments Bethlehem PA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Bethlehem, PA",
      "h2_subtitle": "Discover pet-friendly living in Bethlehem, PA. Valley Park Apartments offers welcoming spaces for both you and your furry friends.",
      "page_copy": "Looking for pet friendly apartments in Bethlehem, PA? Look no further than Valley Park Apartments. Here, both residents and their furry companions are welcomed with open arms. Our pet-friendly spaces include a dedicated dog park where your pets can play and socialize. At Valley Park, we understand the importance of having a home where everyone, including your pets, feels comfortable and valued. \n\nSituated in a prime location, Valley Park Apartments not only offers convenience but also ensures that every member of the family, including pets, enjoys a fulfilling lifestyle. Our community provides spacious living accommodations and a variety of amenities, including a swimming pool, fitness center, and picnic areas. Experience a harmonious blend of comfort and pet-friendly features, making Valley Park Apartments the perfect place for you and your pets in Bethlehem, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Bethlehem, PA",
      "seo_description": "Valley Park Apartments offers pet-friendly living in Bethlehem, PA, with amenities like a dog park. Perfect home for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-with-swimming-pool-lehigh-county-284",
      "search_query": "apartments with swimming pool Lehigh County",
      "category": "Amenity",
      "h1_title": "Lehigh County Apartments with Pool",
      "h2_subtitle": "Enjoy leisure and relaxation with our swimming pool in Lehigh County. Valley Park Apartments offers resort-style living.",
      "page_copy": "If you're in search of apartments with a swimming pool in Lehigh County, Valley Park Apartments in Bethlehem, PA, is the perfect choice. Our community features a refreshing swimming pool that stands out as a prime amenity, providing a perfect place to unwind and enjoy warm days. Whether you prefer swimming laps or lounging poolside, our pool area is designed for relaxation and enjoyment.\n\nLocated in the heart of Lehigh County, Valley Park Apartments combines convenience with modern living. Aside from the swimming pool, residents can take advantage of additional amenities, such as a state-of-the-art fitness center, picnic areas, and off-street parking. Our spacious one and two-bedroom floor plans are tailored for comfort, ensuring a delightful living experience in a vibrant community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lehigh County Apartments with Pool",
      "seo_description": "Valley Park Apartments in Lehigh County features a swimming pool and modern amenities for ultimate leisure and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-18018-636",
      "search_query": "fitness center apartments near 18018",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center near 18018",
      "h2_subtitle": "Live an active lifestyle near 18018 with our fitness center apartments. Valley Park Apartments offers top-notch amenities.",
      "page_copy": "Searching for fitness center apartments near 18018? Valley Park Apartments in Bethlehem, PA, offers the perfect home for fitness enthusiasts. Our state-of-the-art fitness center is designed to support your active lifestyle, providing a convenient and efficient space for workouts without leaving the comfort of your community. Enjoy access to modern exercise equipment that caters to a variety of training needs, whether you're lifting weights or enjoying cardio sessions.\n\nNestled in a vibrant area near the 18018 area, Valley Park Apartments combines excellent amenities with ideal location. Beyond our fitness center, residents can enjoy other desirable features such as a swimming pool and pet-friendly spaces. Choose from our spacious one and two-bedroom floor plans and experience the perfect blend of convenience and modern living at Valley Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center near 18018",
      "seo_description": "Valley Park Apartments near 18018 features a top fitness center. Ideal for those seeking an active lifestyle in a modern setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-lehigh-county-767",
      "search_query": "air conditioned apartments Lehigh County",
      "category": "Amenity",
      "h1_title": "Lehigh County Air Conditioned Apartments",
      "h2_subtitle": "Stay cool in air conditioned apartments in Lehigh County. Experience comfort and modern living at Valley Park Apartments.",
      "page_copy": "For those seeking air conditioned apartments in Lehigh County, Valley Park Apartments in Bethlehem, PA, offers exactly what you're looking for. Our well-appointed living spaces are fully equipped with air conditioning, ensuring a comfortable environment all year round. Experience the convenience and comfort of having climate control at your fingertips, perfect for both the warm summers and chilly winters.\n\nValley Park Apartments not only provides air-conditioned living but also a range of amenities designed for modern living. Enjoy facilities such as a refreshing swimming pool, state-of-the-art fitness center, and pet-friendly areas. Choose from our selection of spacious one and two-bedroom floor plans in a community that prioritizes resident satisfaction and comfort. Your ideal home in Lehigh County awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Lehigh County Air Conditioned Apartments",
      "seo_description": "Discover air conditioned comfort at Valley Park Apartments in Lehigh County. Modern amenities and climate-controlled living await you.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-bethlehem-pa-465",
      "search_query": "one bedroom apartments bethlehem pa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Bethlehem, PA",
      "h2_subtitle": "Explore our one bedroom apartments in Bethlehem, PA. Valley Park Apartments offers modern living in a convenient location.",
      "page_copy": "If you're searching for one bedroom apartments in Bethlehem, PA, Valley Park Apartments has the perfect home for you. Our thoughtfully designed one-bedroom floor plans provide ample space and modern conveniences, making them ideal for singles or couples looking for a cozy yet functional living environment. Each apartment is designed with comfort in mind, featuring modern finishes and plenty of natural light.\n\nNestled in a prime Bethlehem location, Valley Park Apartments offers residents access to a variety of exceptional amenities. From our state-of-the-art fitness center to refreshing swimming pool and picnic areas, our community provides a lifestyle full of opportunities for leisure and recreation. Experience the blend of comfort and convenience at Valley Park, where our one-bedroom apartments serve as the perfect retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Bethlehem, PA",
      "seo_description": "Find your ideal one bedroom apartment at Valley Park Apartments in Bethlehem, PA. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-lehigh-county-652",
      "search_query": "two bedroom apartments lehigh county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Lehigh County",
      "h2_subtitle": "Discover two bedroom apartments in Lehigh County at Valley Park. Enjoy spacious living with modern amenities in Bethlehem, PA.",
      "page_copy": "Searching for spacious two bedroom apartments in Lehigh County? Valley Park Apartments in Bethlehem, PA, offers the perfect blend of comfort and style. Our well-designed two-bedroom floor plans provide ample space, making them ideal for families, roommates, or individuals needing a home office. Each apartment features contemporary finishes and large windows to let in plenty of natural light.\n\nValley Park Apartments enhances your living experience with exceptional community amenities such as a state-of-the-art fitness center, a sparkling swimming pool, and pet-friendly areas including a dog park. Located in the heart of Lehigh County, our apartments offer easy access to local dining, shopping, and entertainment options. Make Valley Park Apartments your home and experience the best of Lehigh County living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Lehigh County",
      "seo_description": "Find spacious two bedroom apartments at Valley Park in Lehigh County. Enjoy modern living with premium amenities in Bethlehem, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-near-clearview-elementary-school-pa-251",
      "search_query": "apartments near Clearview Elementary School PA",
      "category": "School",
      "h1_title": "Apartments Near Clearview Elementary School",
      "h2_subtitle": "Find convenient apartments near Clearview Elementary School. Valley Park Apartments offers an ideal location for families in Bethlehem, PA.",
      "page_copy": "Families searching for apartments near Clearview Elementary School, PA, will find an ideal home at Valley Park Apartments. Located just a short distance away, our community offers easy commuting for families with school-aged children. Enjoy the peace of mind that comes with living near quality education while benefiting from the many amenities our community provides.\n\nValley Park Apartments features spacious one and two-bedroom floor plans designed for modern family living. Residents can take advantage of our family-friendly amenities, including a picnic area and off-street parking, as well as a beautiful swimming pool and fitness center. Our apartment community in Bethlehem, PA, provides the perfect blend of comfort, convenience, and community spirit. Discover a place where families can thrive and enjoy life's simple pleasures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Clearview Elementary School, PA",
      "seo_description": "Discover family-friendly living at Valley Park Apartments near Clearview Elementary School in Bethlehem, PA. Perfect location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-close-to-nitschmann-middle-school-433",
      "search_query": "apartments close to Nitschmann Middle School Bethlehem",
      "category": "School",
      "h1_title": "Apartments Close to Nitschmann Middle School",
      "h2_subtitle": "Explore apartments close to Nitschmann Middle School in Bethlehem. Enjoy convenience and community at Valley Park Apartments.",
      "page_copy": "Valley Park Apartments offers an exceptional living experience for families looking for apartments close to Nitschmann Middle School in Bethlehem, PA. Our location provides parents and students with a stress-free commute, ensuring more time for important family moments. The proximity to the school makes living at Valley Park not only convenient but also beneficial for students’ daily routines.\n\nOur community features both one and two-bedroom options equipped with modern amenities aimed at elevating your lifestyle. Residents can enjoy leisure activities in our spacious picnic area, cool off in the refreshing swimming pool, or stay active at the state-of-the-art fitness center. Valley Park Apartments combines practical living with a touch of community spirit, ensuring a comfortable home environment near Nitschmann Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Nitschmann Middle School",
      "seo_description": "Find convenient living at Valley Park Apartments near Nitschmann Middle School in Bethlehem, PA. Enjoy family-friendly amenities and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "james-buchanan-elementary-vicinity-apartments-18018-241",
      "search_query": "James Buchanan Elementary School vicinity apartments 18018",
      "category": "School",
      "h1_title": "Apartments Near James Buchanan Elementary",
      "h2_subtitle": "Looking for apartments in the vicinity of James Buchanan Elementary School? Discover the perfect home at Valley Park Apartments in 18018.",
      "page_copy": "For families seeking James Buchanan Elementary School vicinity apartments in the 18018 area, Valley Park Apartments offers an ideal blend of location and comfort. Situated within easy reach of the school, our community provides a stress-free commute for kids and parents alike, fostering a balanced lifestyle that values education and convenience.\n\nValley Park Apartments presents a choice of roomy one and two-bedroom layouts designed to cater to modern family needs. Residents can enjoy a host of amenities, such as a picnic area, off-street parking, and opportunities for resident activities. Our pet-friendly spaces, complete with a dedicated dog park, and amenities like a swimming pool and fitness center, make Valley Park a welcoming community in the heart of Bethlehem, perfect for those who value proximity to James Buchanan Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near James Buchanan Elementary",
      "seo_description": "Discover Valley Park Apartments near James Buchanan Elementary in the 18018 area. Enjoy convenience with family-friendly amenities and modern living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-near-notre-dame-of-bethlehem-school-389",
      "search_query": "apartments near Notre Dame of Bethlehem School",
      "category": "School",
      "h1_title": "Apartments Near Notre Dame of Bethlehem School",
      "h2_subtitle": "Explore apartments near Notre Dame of Bethlehem School. Valley Park Apartments offer ideal living spaces for families in Bethlehem.",
      "page_copy": "Valley Park Apartments is your go-to choice for apartments near Notre Dame of Bethlehem School. Located in Bethlehem, PA, our community offers the perfect location for families seeking quality education closeby. The short distance to the school makes morning routines smoother and ensures children can engage in extracurricular activities without hassle.\n\nThe living options at Valley Park include spacious one and two-bedroom apartments, designed with modern amenities and your comfort in mind. Our community boasts a variety of wonderful features such as a swimming pool, a picnic area for family gatherings, and a fully-equipped fitness center. Parents will also appreciate the pet-friendly environment with a dedicated dog park, making Valley Park a well-rounded choice for families in proximity to Notre Dame of Bethlehem School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Notre Dame of Bethlehem School",
      "seo_description": "Find the perfect family home at Valley Park Apartments near Notre Dame of Bethlehem School. Enjoy modern amenities with easy access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "moravian-university-apartments-bethlehem-pa-255",
      "search_query": "Moravian University apartments Bethlehem PA",
      "category": "School",
      "h1_title": "Apartments Near Moravian University",
      "h2_subtitle": "Discover the best apartments near Moravian University in Bethlehem, PA at Valley Park Apartments, where comfort meets convenience.",
      "page_copy": "Valley Park Apartments offers exceptional living for students and faculty looking for Moravian University apartments in Bethlehem, PA. With our prime location, commuting to Moravian University is a breeze, providing a short and stress-free experience. Our community is perfectly positioned to help you balance academics with leisure seamlessly.\n\nValley Park Apartments provides spacious one and two-bedroom floor plans tailored to meet modern needs. Residents can indulge in amenities like our state-of-the-art fitness center, a sparkling swimming pool, and a serene picnic area. This pet-friendly community, featuring a dedicated dog park, ensures that both you and your furry friends feel at home. Join us at Valley Park Apartments—where student life meets modern living in Bethlehem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Moravian University in Bethlehem",
      "seo_description": "Live close to Moravian University at Valley Park Apartments in Bethlehem, PA. Enjoy modern amenities and a convenient location tailored for students.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "bethlehem-apartments-near-lehigh-university-764",
      "search_query": "apartments in Bethlehem near Lehigh University",
      "category": "School",
      "h1_title": "Apartments Near Lehigh University, Bethlehem",
      "h2_subtitle": "Find convenient living in Bethlehem with apartments near Lehigh University at Valley Park Apartments, designed for modern needs.",
      "page_copy": "Explore living at Valley Park Apartments if you're searching for apartments in Bethlehem near Lehigh University. Located ideally within easy reach of the campus, our community offers unparalleled convenience for students and faculty members alike. Proximity to Lehigh University makes it easy for residents to attend classes, engage in campus activities, and savor university events.\n\nValley Park Apartments promises a blend of comfort with modernity through our spacious one and two-bedroom units. Our range of amenities includes a state-of-the-art fitness center, a swimming pool, and plenty of spaces for relaxation, such as a picnic area. Our pet-friendly environment, complete with a designated dog park, ensures that both you and your furry companions love living here. Join Valley Park Apartments and experience a fully supportive living community in Bethlehem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bethlehem Apartments Near Lehigh University",
      "seo_description": "Find student-friendly accommodation at Valley Park Apartments in Bethlehem, near Lehigh University. Enjoy modern living with convenient campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-near-lehigh-valley-hospital-muhlenberg-115",
      "search_query": "apartments near Lehigh Valley Hospital–Muhlenberg Bethlehem",
      "category": "Hospital",
      "h1_title": "Apartments Near Lehigh Valley Hospital–Muhlenberg",
      "h2_subtitle": "Discover comfortable apartments near Lehigh Valley Hospital–Muhlenberg in Bethlehem at Valley Park Apartments, where modern living meets convenience.",
      "page_copy": "For those seeking apartments near Lehigh Valley Hospital–Muhlenberg in Bethlehem, Valley Park Apartments provides an excellent living choice. Our convenient location ensures that healthcare professionals and hospital visitors have easy access to the hospital, making daily commutes quick and hassle-free.\n\nValley Park Apartments offers spacious one and two-bedroom floor plans with contemporary designs that cater to modern lifestyles. Residents can enjoy a variety of amenities, including a refreshing swimming pool, a well-equipped fitness center, and scenic picnic areas ideal for relaxation. With our pet-friendly spaces, including a dedicated dog park, Valley Park Apartments offers a warm, welcoming community for both you and your pets. Discover the benefits of living in a well-connected and community-driven environment here at Valley Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lehigh Valley Hospital–Muhlenberg",
      "seo_description": "Find convenient living at Valley Park Apartments near Lehigh Valley Hospital–Muhlenberg in Bethlehem. Ideal for healthcare professionals and visitors alike.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "lehigh-county-apartments-near-st-lukes-university-hospital-367",
      "search_query": "St. Luke's University Hospital nearby Lehigh County apartments",
      "category": "Hospital",
      "h1_title": "Lehigh County Apartments Near St. Luke's University",
      "h2_subtitle": "Explore ideal Lehigh County apartments near St. Luke's University Hospital at Valley Park Apartments, offering comfort and convenience.",
      "page_copy": "Valley Park Apartments is an excellent choice for those looking for Lehigh County apartments near St. Luke's University Hospital. Our community's strategic location ensures quick access to the hospital, making it a perfect living option for healthcare workers and frequent hospital visitors.\n\nOur spacious one and two-bedroom floor plans at Valley Park Apartments are designed with modern living in mind. Amenities such as a top-tier fitness center, a refreshing swimming pool, and a relaxing picnic area enhance your living experience. Our pet-friendly atmosphere welcomes you and your furry friends, with a dog park specifically for their enjoyment. Experience the balance of professional and personal life at Valley Park Apartments, perfectly situated for your lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Luke's University Hospital",
      "seo_description": "Discover Valley Park Apartments in Lehigh County near St. Luke's University Hospital, offering modern amenities and prime location for residents.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-near-monocacy-park-bethlehem-pa-41",
      "search_query": "apartments near Monocacy Park Bethlehem PA",
      "category": "Park",
      "h1_title": "Apartments Near Monocacy Park, Bethlehem",
      "h2_subtitle": "Discover ideal living with apartments near Monocacy Park in Bethlehem at Valley Park Apartments, perfectly blending nature and comfort.",
      "page_copy": "Valley Park Apartments provides the perfect location for those interested in apartments near Monocacy Park in Bethlehem, PA. Nestled close to this beautiful park, our apartments offer an exceptional living environment that blends urban solidity with natural serenity, ideal for outdoor enthusiasts and nature lovers.\n\nChoose from spacious one and two-bedroom layouts at Valley Park Apartments, where modern comforts meet inviting design. Enjoy our on-site amenities such as a state-of-the-art fitness center and a refreshing swimming pool. The picnic areas offer great spots to unwind, while our pet-friendly spaces, including a delightful dog park, ensure that all members of your household, including the furry ones, feel at home. Valley Park Apartments is where you find your peaceful haven right in Bethlehem.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Monocacy Park Bethlehem PA",
      "seo_description": "Live near Monocacy Park at Valley Park Apartments in Bethlehem, PA. Enjoy natural charm and modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-by-sand-island-park-lehigh-county-289",
      "search_query": "apartments by Sand Island Park Lehigh County",
      "category": "Park",
      "h1_title": "Apartments by Sand Island Park",
      "h2_subtitle": "Discover the perfect apartments by Sand Island Park in Lehigh County. Valley Park Apartments offers convenience and comfort.",
      "page_copy": "If you're searching for apartments by Sand Island Park in Lehigh County, Valley Park Apartments is an ideal choice. Our community combines a convenient location next to the beautiful park with the modern amenities you desire, making it perfect for nature lovers and those looking to enjoy recreational activities.\n\nAt Valley Park Apartments, we offer spacious one and two-bedroom floor plans designed for contemporary living. Our residents enjoy a range of amenities including a refreshing swimming pool and a fully-equipped fitness center. Our pet-friendly community, with its own dog park, welcomes your four-legged companions. Experience a balanced lifestyle with easy access to Sand Island Park while living in comfort and style at Valley Park Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Sand Island Park Lehigh County",
      "seo_description": "Live near Sand Island Park in Lehigh County at Valley Park Apartments, offering modern amenities and a pet-friendly atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "valley-park-apartments-near-south-mountain-park-108",
      "search_query": "Valley Park Apartments near South Mountain Park",
      "category": "Park",
      "h1_title": "Valley Park Apartments by South Mountain Park",
      "h2_subtitle": "Embrace a lifestyle of convenience at Valley Park Apartments, located near South Mountain Park. Enjoy natural beauty and modern amenities.",
      "page_copy": "Situated near the stunning South Mountain Park, Valley Park Apartments offers a unique blend of urban living and nature's tranquility. This proximity to the park makes it the ideal location for those who relish outdoor adventures and scenic views right at their doorstep.\n\nValley Park Apartments provides spacious one and two-bedroom options designed with modern elegance. Our community amenities include a sparkling swimming pool, a dog park, and a state-of-the-art fitness center, ensuring that residents have everything they need right at home. With short-term lease options available, Valley Park is perfect for anyone seeking a flexible, comfortable lifestyle near South Mountain Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Valley Park Apartments by South Mountain Park",
      "seo_description": "Enjoy living at Valley Park Apartments near South Mountain Park, offering convenience and modern amenities in Bethlehem, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "bethlehem-pa-apartments-near-saucon-rail-trail-964",
      "search_query": "Bethlehem PA apartments near Saucon Rail Trail",
      "category": "Park",
      "h1_title": "Bethlehem PA Apartments by Saucon Rail Trail",
      "h2_subtitle": "Discover the charm of Bethlehem, PA apartments close to Saucon Rail Trail. Enjoy convenient living with easy trail access.",
      "page_copy": "Valley Park Apartments, located in Bethlehem, PA, is an excellent choice for those seeking apartments near the Saucon Rail Trail. Our community offers the perfect blend of convenience and outdoor adventure, providing residents with easy access to a beautiful trail ideal for biking, running, or a leisurely stroll.\n\nIn addition to a prime location, Valley Park Apartments features spacious one and two-bedroom floor plans, designed with modern comforts in mind. Revel in amenities like our refreshing pool, inviting picnic area, and a fitness center to stay active year-round. With a pet-friendly atmosphere and short-term leases available, living by the Saucon Rail Trail has never been more appealing than at Valley Park Apartments in Bethlehem, PA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bethlehem PA Apartments by Saucon Rail Trail",
      "seo_description": "Live at Valley Park Apartments near Saucon Rail Trail, offering modern amenities and trail access in Bethlehem, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-near-janet-johnston-housenick-Memorial-park-961",
      "search_query": "apartments close to Janet Johnston Housenick Memorial Park",
      "category": "Park",
      "h1_title": "Apartments Near Janet Johnston Housenick Park",
      "h2_subtitle": "Explore Valley Park Apartments, perfectly situated close to Janet Johnston Housenick Memorial Park. Ideal for nature enthusiasts.",
      "page_copy": "Nestled close to the peaceful surroundings of Janet Johnston Housenick Memorial Park, Valley Park Apartments is a haven for those who love outdoor activities and nature. Our location provides residents with convenient access to scenic trails and beautiful park vistas, perfect for relaxing weekends and outdoor adventures.\n\nValley Park Apartments features spacious one and two-bedroom units with modern amenities that cater to your lifestyle needs. From a sparkling pool and dog-friendly spaces to a state-of-the-art fitness center, our community ensures comfort and leisure are seamlessly integrated. Discover the perfect home base for enjoying all that nature and community living have to offer at Valley Park Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Janet Johnston Housenick Park",
      "seo_description": "Valley Park Apartments offers easy access to Janet Johnston Housenick Memorial Park. Enjoy the best of modern living and nature in Bethlehem, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166359",
      "source": "custom",
      "page_item_url": "apartments-near-lehigh-valley-international-airport-137",
      "search_query": "apartments near Lehigh Valley International Airport Bethlehem PA",
      "category": "Transit",
      "h1_title": "Apartments by Lehigh Valley International Airport",
      "h2_subtitle": "Conveniently located near Lehigh Valley International Airport, Valley Park Apartments offer easy access and modern amenities in Bethlehem, PA.",
      "page_copy": "Discover superb convenience at Valley Park Apartments, ideally situated close to Lehigh Valley International Airport. Perfect for frequent travelers or aviation enthusiasts, our community in Bethlehem, PA provides seamless airport access without compromising on comfort and style.\n\nValley Park Apartments offers spacious one and two-bedroom floor plans, replete with modern amenities like a fitness center, dog park, and refreshing swimming pool. Whether you're returning from a trip or working locally, enjoy the ease of off-street parking and short-term lease options. Our pet-friendly environment and array of resident activities ensure that you feel right at home, while still being moments away from the bustling airport route.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of an L-shaped swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a015dc-a316-775d-8bc0-4ac6af7613eb",
        "storage_key": "property/6767906449166359/01a015dc-a316-775d-8bc0-4ac6af7613eb.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Lehigh Valley International Airport",
      "seo_description": "Live at Valley Park Apartments near Lehigh Valley International Airport. Enjoy easy travel access with modern amenities in Bethlehem, PA.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5096"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976292120"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973460"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N2J4CGSD"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livevalleypark.fatwin.com/api/websites/resources/1?x=bnhFMm1kZVNCQndpYTYwNEdhcWdGVjVxeUhnYW9ldWZUNkJtSm1OdlhZdStYb1UvaGxJSzlSQjg0VElMSmhmNlc3WGQ5dXJ6VmFkSzdFZk5aRmp4aWc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/m9pz4m07vk1"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954768a4-43e6-11ef-85d8-9fb6b94edca2"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954768a4-43e6-11ef-85d8-9fb6b94edca2/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954768a4-43e6-11ef-85d8-9fb6b94edca2/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkYxZ1dSK3A0OUFvdXJnT3RsSHhnMHc9PSIsInZhbHVlIjoiQUZpY3BxRnRIODNQeGpGUnBETE1Mdz09IiwibWFjIjoiNjhlNWU2YzIwNjJlYjhhMzYyOWY1NDAxNjU4Nzk5YmQzMjllZWY5YmExZGQwODJkYmY0OTkwYzI3MGVmMDBiMyJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5096",
  "custom_repli_id": "9976292120",
  "custom_realpage_id": "4973460",
  "custom_google_gtm_id": "GTM-N2J4CGSD",
  "custom_perq_script_url": "https://livevalleypark.fatwin.com/api/websites/resources/1?x=bnhFMm1kZVNCQndpYTYwNEdhcWdGVjVxeUhnYW9ldWZUNkJtSm1OdlhZdStYb1UvaGxJSzlSQjg0VElMSmhmNlc3WGQ5dXJ6VmFkSzdFZk5aRmp4aWc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/m9pz4m07vk1",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "954768a4-43e6-11ef-85d8-9fb6b94edca2",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954768a4-43e6-11ef-85d8-9fb6b94edca2/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954768a4-43e6-11ef-85d8-9fb6b94edca2/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkYxZ1dSK3A0OUFvdXJnT3RsSHhnMHc9PSIsInZhbHVlIjoiQUZpY3BxRnRIODNQeGpGUnBETE1Mdz09IiwibWFjIjoiNjhlNWU2YzIwNjJlYjhhMzYyOWY1NDAxNjU4Nzk5YmQzMjllZWY5YmExZGQwODJkYmY0OTkwYzI3MGVmMDBiMyJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "89320056-85f0-49ba-b203-8b317a2f9b8a",
  "custom_audioeye_site_hash": "8ef04b8e4af6047955455e2f44a26b66"
};

export const generatedAt = '2026-10-22T20:04:38.753Z';
